import React, { useCallback, useEffect, useRef, useState } from 'react';
import backicon from '../../../../../Assets/icons/backIcon.svg';
import deleteIcon from '../../../../../Assets/icons/trash.svg';
import editIcon from '../../../../../Assets/icons/Un-Checkbox.svg';
import './index.scss';
import { useLocation, useNavigate } from 'react-router-dom';
import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer } from 'react-toastify';
import DynamicForm from '../../../../customformComponent/customForm/DynamicForm';
import ReactSignatureCanvas from 'react-signature-canvas';
import moment from 'moment';
import { Modal, Offcanvas, Placeholder } from 'react-bootstrap';
import axiosInstance from '../../../../../http.common';
import CustomTable from '../../../../customComponents/CustomTable';
import Serial from './../../../../DealerManagement/Logistics/PhysicalStockTaking/PhysicalStockinComponents/Serial';
import AddIssueDynemicForm from '../../addIssueDynemicFrom';
import { format, formatDuration } from 'date-fns';
import Drawer from 'react-modern-drawer';
import AddJobCardIssue from '../AddJobCardIssue';
// import AddComplain from "./AddComplain";
import {
  COMPLAIN_TABLE_HEADERS,
  ComplainkeyMapping,
} from '../../../../../constants/JobCardComplaints';
import DetailsTable from '../../../Logistics/PO Approval/PoApprovalDetails/DetailsTable';
import { showCustomAlert } from '../../../../customComponents/CustomSweetAlert';
import Swal from 'sweetalert2';
import { min18YearsAgo } from '../../../../../constants/DOBCommon';
import { showErrorAlert } from '../../../../customComponents/CustomSweetAlert/errorsweetalert';
import Loader from '../../../../customComponents/CustomLoader';
import { showAlert } from '../../../../customComponents/CustomSweetAlert/ShowAlert';

const EditJobCard = () => {
  const location = useLocation();

  const [jobCardVal, setJobCardIdVal] = useState();
  const [remarkError, setRemarkError] = useState('');
  const [itemIdVal, setItemIdVal] = useState();
  const [statusVal, setStatusVal] = useState();
  const [productData, setProductData] = useState([]);

  const [editJobcardDetails, setEditJobcardDetails] = useState();

  const [paidAmount, setPaidAmount] = useState();

  const [rejectRemarkVal, setRejectRemarkVal] = useState();
  const [rejectRemarkOne, setRejectRemarkOne] = useState();
  // Conditions for CustomerForm and VehicleForms
  const { jobCardDataDetails } = location?.state || {};
  console.log(jobCardDataDetails, 'jobCardDataDetailsValue');

  const { customer_id } = location?.state || {};
  console.log(customer_id, 'customerIdValue');
  const [formData, setFormData] = useState({
    Trans_Date: new Date(),
    Allocation_Date: new Date(),
  });

  const [customerVehicleId, setCustomerVehicleId] = useState(0);

  const [engineerOptions, setEngineerOptions] = useState([]);

  const [showVehicleForm, setShowVehicleForm] = useState(false);
  const [openCustomerForm, setOpenCustomerForm] = useState(false);
  const [make, setMake] = useState([]);
  const [model, setModel] = useState([]);
  const [product, setProduct] = useState([]);
  const [subproduct, setSubproduct] = useState([]);
  const [variantDD, setVariantDD] = useState([]);
  const [complaindata, setComplainData] = useState([]);

  const [replacedBattery, setReplacedBattery] = useState([]);

  const [customerId, setCustomerId] = useState([]);

  //   Remark state
  const [remark, setRemark] = useState('');
  const [isModalOpen, setIsModalOpen] = useState(false);

  const [color, setColor] = useState([]);
  const [fuelType, setFuelType] = useState([]);

  const [kiloMeterData, setKiloMeterData] = useState('');
  const [remainingDaysVal, setRemainingDaysVal] = useState({});

  const dealerId = localStorage.getItem('dealerId');
  const [dealerIdData, setdealerIdVal] = useState();

  const token = localStorage.getItem('authToken');
  // const businessPartnerId = 1;
  const [isLoading, setIsLoading] = useState(false);
  const [loading, setLoading] = useState(true);
  const [validationErrors, setValidationErrors] = useState({});
  const [signatureModel, setSignatureModel] = useState(false);
  const [jobCardType, setJobCardType] = useState([]);
  const [customerList, setCustomerList] = useState([]);
  const [VeriantListShow, setVeriantListShow] = useState(false);
  const [veriantListData, setVeriantListData] = useState([]);
  const [supervisorList, setSupervisorList] = useState([]);
  const [openCustomerModel, setOpenCustomerModel] = useState(false);
  const [showParentDesignation, setShowParentDesignation] = useState(false);
  const [occupationDD, setOccupationDD] = useState([]);
  const [totalEstimatedCost, setTotalEstimatedCost] = useState();
  const [activeButton, setActiveButton] = useState('customer');
  const [enableSubmitButton, setEnableSubmitButton] = useState(false);
  const [customerIdValue, setCustomerIdValue] = useState(0);
  const [languageDD, setLanguageDD] = useState([]);
  const [titleDD, setTitleDD] = useState([]);
  const sigCanvas = useRef();
  const [isOpen, setIsOpen] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [vinNoValData, setVinNoValData] = useState('');
  const [isJobCardCreated, setIsJobCardCreated] = useState(false);
  const [jobCardNo, setJobCardNumber] = useState();

  const [currentPage, setCurrentPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [totalRecords, setTotalRecords] = useState(0);

  const [batteryModalOpen, setBatteryModalOpen] = useState(false);

  const [batteryDetails, setBatteryDetails] = useState({});
  const [selectedOldBatteries, setSelectedOldBatteries] = useState([]);

  const handleOldBatterySelect = (e, batteryNo) => {
    if (e.target.checked) {
      // Add the selected battery
      setSelectedOldBatteries((prev) => [...prev, batteryNo]);
    } else {
      // Remove it if unchecked
      setSelectedOldBatteries((prev) => prev.filter((b) => b !== batteryNo));
    }
  };

  const navigate = useNavigate();

  const businessPartnerId = localStorage.getItem('business_partner_id');
  const userType = localStorage.getItem('UserType');

  const engineerId = localStorage.getItem('engineer_id');

  console.log(businessPartnerId, 'businesspartnerId');

  const toggleBatteryModalOpen = () => {
    setBatteryModalOpen(true);
  };

  const toggleBatteryModalClose = () => {
    setBatteryModalOpen(false);
  };

  const existingComplaintsData =
    JSON.parse(localStorage.getItem('JobCardComplainData')) || [];

  const openSubmitModal = () => {
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setRemark('');
  };

  console.log(existingComplaintsData, 'exisTingComplainsData');

  const toggleDrawer = () => {
    setIsOpen((prevState) => !prevState);
    if (isEdit) {
      setIsEdit(!isEdit);
    }
  };

  const apiCall = async (formData) => {
    try {
      const payload = {
        reqType: 'V',
        reqNumber: formData.vin_no,
      };

      const response = await axiosInstance.post(
        'jobcard/check-warranty',
        payload,
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
        },
      );

      const fetchedData = response?.data?.data;
      console.log(fetchedData, 'fetchedData');

      // Store all remaining days in an object
      const remainingDaysData = {
        remainingDays: fetchedData?.remainingDays || 0,
        btryremaining_days: fetchedData?.btryremaining_days || 0,
        cntrlremaining_days: fetchedData?.cntrlremaining_days || 0,
        mtrremaining_days: fetchedData?.mtrremaining_days || 0,
        chrgrremaining_days: fetchedData?.chrgrremaining_days || 0,
        covrtremaining_days: fetchedData?.covrtremaining_days || 0,
      };

      console.log(remainingDaysData, 'remainingDaysData');

      setRemainingDaysVal(remainingDaysData);

      setFormData((prevData) => ({
        ...prevData,
        dealer_name: fetchedData.dealer_name,
        warrantyFrom: fetchedData.warrantyFrom,
        warrantyTo: fetchedData.warrantyTo,
        kiloMeter: fetchedData.kilometer,
        tradeDate: fetchedData.trade_date,
        remainingdays:
          remainingDaysData.remainingDays <= 0
            ? '0'
            : remainingDaysData.remainingDays,
        batteryWarrntyFrom: fetchedData?.batteryWarrntyFrom,
        batteryWarrntyTo: fetchedData?.batteryWarrntyTo,
        btryremaining_days: fetchedData?.btryremaining_days,
        cntrlwarrantyFrom: fetchedData?.cntrlwarrantyFrom,
        cntrlwarrantyTo: fetchedData?.cntrlwarrantyTo,
        cntrlremaining_days: fetchedData?.cntrlremaining_days,
        mtrwarrantyFrom: fetchedData?.mtrwarrantyFrom,
        mtrwarrantyTo: fetchedData?.mtrwarrantyTo,
        mtrremaining_days: fetchedData?.mtrremaining_days,
        chrgrwarrantyFrom: fetchedData?.chrgrwarrantyFrom,
        chrgrwarrantyTo: fetchedData?.chrgrwarrantyTo,
        chrgrremaining_days: fetchedData?.chrgrremaining_days,
        covrtwarrantyFrom: fetchedData?.covrtwarrantyFrom,
        covrtwarrantyTo: fetchedData?.covrtwarrantyTo,
        covrtremaining_days: fetchedData?.covrtremaining_days,
        claimName: fetchedData?.customerName,
      }));

      console.log(response);
    } catch (error) {
      console.log(error, 'error');
    }
  };

  useEffect(() => {
    fetchEngineer();
  }, []);

  const fetchEngineer = async () => {
    try {
      setLoading(true);
      const response = await axiosInstance.get(
        `/engineer/ddllEngineer/${jobCardDataDetails.dealer_id}`,
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
        },
      );
      const dealerOptions = response?.data?.data.map((dealer) => ({
        value: dealer.engineer_id,
        label: dealer.engineer_name,
      }));
      setEngineerOptions(dealerOptions);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCustomerDataValues();
  }, []);

  const fetchCustomerDataValues = async (page = 0, pageSize = 1) => {
    try {
      const response = await axiosInstance.get(
        `/sales/vin-customer-details/${customer_id}`,
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
        },
      );

      const fetchedData = response?.data?.data[0];
      console.log(fetchedData, 'fetchedData');

      setFormData((pre) => ({
        ...pre,
        vin_no: fetchedData?.vin_no,
        pincode: fetchedData?.pincode,
        contact_no: fetchedData?.mobile_no,
      }));

      const vinNoValue = fetchedData?.vin_no;
      setVinNoValData(vinNoValue);

      // if (response?.status) {
      //   setJobCardType(
      //     response?.data?.data?.data?.map((jobTypeDetails, index) => ({
      //       label: jobTypeDetails?.name,
      //       value: jobTypeDetails?.id,
      //     }))
      //   );
      // }
    } catch (error) {
      console.error('Error fetching business partners:', error);
    }
  };

  const fetchJobCardList = async (page = 0, pageSize = 1) => {
    try {
      const response = await axiosInstance.post('/jobcard/jobtype', {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      });

      if (response?.status) {
        setJobCardType(
          response?.data?.data?.data?.map((jobTypeDetails, index) => ({
            label: jobTypeDetails?.name,
            value: jobTypeDetails?.id,
          })),
        );
      }
    } catch (error) {
      console.error('Error fetching business partners:', error);
    }
  };

  const handleDrawerFormCustomer = async (formData) => {
    const errors = {};
    let isValid = true;

    CustomerFromInput.forEach((field) => {
      console.log('field>>', field);
      if (field.required && !formData[field.name]) {
        errors[field.name] = 'This field is required';
        isValid = false;
      } else if (
        field.required &&
        field.validation &&
        field.validation.pattern &&
        !field.validation.pattern.test(formData[field.name])
      ) {
        errors[field.name] = field.validation.message;
        isValid = false;
      }
    });

    if (!isValid) {
      setValidationErrors(errors);
      console.log('validationErrors', validationErrors);
      return;
    }

    setIsLoading(true);

    try {
      const formattedDOB = moment(formData.dob).format('YYYY-MM-DD');

      // Display confirmation dialog before proceeding
      const confirmation = await Swal.fire({
        title: 'Are you sure?',
        text: 'Do you want to add this customer?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes',
        cancelButtonText: 'Cancel',
      });

      // If the user cancels, exit early
      if (!confirmation.isConfirmed) {
        setIsLoading(false); // Reset loading state
        return;
      }

      // Perform API call to submit customer form data
      const response = await axiosInstance.post(
        '/jobcard/create',
        {
          business_partner_id: businessPartnerId == 0 ? 1 : businessPartnerId,
          title_id: formData.title_id,
          customer_type_id: 1,
          first_name: formData.first_name,
          last_name: formData.last_name,
          email_id: formData.email_id,
          mobile_no: formData.mobile_no,
          dob: formattedDOB,
          address: formData.address,
          occupation_id: formData.occupation_id,
          language_id: formData.language_id,
          pincode: formData.pincode,
          city_id: formData.city_id,
          country_id: formData.country_id,
          state_id: formData.state_id,
          pan_no: formData.pan_no,
          status: 1,
        },
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
        },
      );

      // Check if response is successful
      if (response?.data?.status === 200) {
        Swal.fire({
          title: 'Success!',
          text: 'Customer added successfully.',
          icon: 'success',
          confirmButtonText: 'OK',
        }).then(() => {
          handleVehicleClick(); // Assuming this is for further actions like vehicle association
          setFormData({
            Trans_Date: new Date(),
            Allocation_Date: new Date(),
          });
        });
      }
    } catch (error) {
      console.error('Error submitting form:', error);

      // Show error alert in case of failure
      Swal.fire({
        title: 'Error!',
        text: 'Failed to add the customer. Please try again.',
        icon: 'error',
        confirmButtonText: 'OK',
      });
    } finally {
      setIsLoading(false); // Reset loading state at the end
    }
  };

  const handleBackToCustomerForm = () => {
    setShowVehicleForm(false); // Go back to the Customer form
  };

  const handleDrawerFormVehicle = async (formData) => {
    const errors = {};
    let isValid = true;

    VehicleInputs.forEach((field) => {
      console.log('field>>', field);
      if (field.required && !formData[field.name]) {
        errors[field.name] = 'This field is required';
        isValid = false;
      } else if (
        field.required &&
        field.validation &&
        field.validation.pattern &&
        !field.validation.pattern.test(formData[field.name])
      ) {
        errors[field.name] = field.validation.message;
        isValid = false;
      }
    });

    if (!isValid) {
      setValidationErrors(errors);
      console.log('validationErrors', validationErrors);
      return;
    }

    setIsLoading(true);

    try {
      const formattedDOB = moment(formData.extwarrantystartdate).format(
        'YYYY-MM-DD',
      );
      const formattedEndDate = moment(formData.extwarrantyenddate).format(
        'YYYY-MM-DD',
      );
      const formattedMfgYear = moment(formData.mfgyear).format('YYYY-MM-DD');

      // Display confirmation dialog before proceeding
      const confirmation = await Swal.fire({
        title: 'Are you sure?',
        text: 'Do you want to add this vehicle?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes',
        cancelButtonText: 'Cancel',
      });

      // If the user cancels, exit early
      if (!confirmation.isConfirmed) {
        setIsLoading(false); // Reset loading state
        return;
      }

      // Perform API call to submit vehicle form data
      const response = await axiosInstance.post(
        '/jobcard/createCustomerVehicle',
        {
          business_partner_id: businessPartnerId == 0 ? 1 : businessPartnerId,
          product_id: formData.product_id,
          subproduct_id: formData.subproduct_id,
          make_id: formData.make_id,
          model_id: formData.model_id,
          variant_id: formData.variant_id,
          extwarrantystartdate: formattedDOB,
          extwarrantyenddate: formattedEndDate,
          color_id: formData.color_id,
          fuel_type_id: formData.fuel_type_id,
          chassisno: formData.chassisno,
          engineno: formData.engineno,
          registrationno: formData.registrationno,
          mfgyear: formattedMfgYear,
          isextwarranty: formData.isextwarranty ? 1 : 0,
          extamount: formData.extamount,
          customer_id: formData.customer_id,
          status: 1,
        },
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
        },
      );

      // Check if response is successful
      if (response.status === 200) {
        Swal.fire({
          title: 'Success!',
          text: 'Vehicle added successfully.',
          icon: 'success',
          confirmButtonText: 'OK',
        }).then(() => {
          handleClose(); // Close the form or drawer
          // fetchCustomerList(); // Refresh the customer list if necessary
          setFormData({
            Trans_Date: new Date(),
            Allocation_Date: new Date(),
          });
        });
      }
    } catch (error) {
      console.error('Error submitting form:', error);

      // Show error alert in case of failure
      Swal.fire({
        title: 'Error!',
        text: 'Failed to add the vehicle. Please try again.',
        icon: 'error',
        confirmButtonText: 'OK',
      });
    } finally {
      setIsLoading(false); // Reset loading state at the end
    }
  };

  //   --------------------------------------update form

  // const handleUpdate = async (formData) => {
  //     console.log(formData)

  //     const result = await Swal.fire({
  //         title: "Confirmation",
  //         text: "Are you sure you want to update this record?",
  //         icon: "warning",
  //         showCancelButton: true,
  //         confirmButtonText: "Yes",
  //         cancelButtonText: "No",
  //         showLoaderOnConfirm: true,
  //         preConfirm: async () => {
  //     try{

  //         const formDataPayload = new FormData();

  //         // Append all fields to the FormData object
  //         formDataPayload.append("status", formData.status);
  //         formDataPayload.append("is_complated", 1);
  //         if(userType === "engineeruser" ){
  //           formDataPayload.append("engineer_id", engineerId)
  //         }
  //         if(userType === "businesspartner"){
  //           formDataPayload.append("engineer_id", formData.engineer_id);
  //         }
  //         formDataPayload.append("service_type", formData.service_type);
  //         formDataPayload.append("rejactRemark", remark || ""); // Default value if remark is undefined

  //         formDataPayload.append("repairStatus", formData.repairStatus);
  //         formDataPayload.append("user_type", userType );

  //         // Append the file, if it exists
  //         if (formData.uploadFile) {
  //           formDataPayload.append("uploadFile", formData.uploadFile);
  //         }

  //         const response = await axiosInstance.patch(
  //             `jobcard/update/${jobCardDataDetails.job_card_id}`,
  //             formDataPayload,
  //             {
  //               headers: {
  //                 "Content-Type": "multipart/form-data",
  //                 Authorization: `Bearer ${token}`,
  //               },
  //             }
  //           );

  //           if (response.status === 200) {
  //             Swal.fire({
  //               title: "Success",
  //               text: "Job Card updated successfully!",
  //               icon: "success",
  //               confirmButtonText: "OK",
  //             }).then(() => {
  //               navigate("/manage-services/check-warranty");
  //             });
  //           }

  //     }catch(error){
  //         console.log(error)

  //           const errorMessage = error.response?.data?.message;
  //           console.log(errorMessage, "errorMessage");

  //           showErrorAlert({
  //             title: "Warning",
  //             text:
  //               errorMessage ||
  //               "Something went wrong",
  //             callback: () => {
  //               console.log("Error alert confirmed");
  //             },
  //           });
  //     }
  // },
  // });
  // }

  const handleRejectUpdateOld = async (formData) => {
    console.log(formData, 'formData');

    const result = await Swal.fire({
      title: 'Confirmation',
      text: 'Are you sure you want to update this record?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes',
      cancelButtonText: 'No',
      showLoaderOnConfirm: true,
      preConfirm: async () => {
        try {
          const formDataPayload = new FormData();

          // Append all fields to the FormData object
          formDataPayload.append('status', formData.status);
          formDataPayload.append('is_complated', 1);

          if (userType === 'engineeruser') {
            formDataPayload.append('engineer_id', engineerId);
          }
          // if (userType === "businesspartner") {
          //   formDataPayload.append("engineer_id", formData.engineer_id);
          // }
          // if (userType === "businesspartner") {
          //   formDataPayload.append(
          //     "eng_paid_amount",
          //     formData.eng_paid_amount ? formData.eng_paid_amount : null
          //   );
          // }
          // if (userType === "engineeruser") {
          //   formDataPayload.append("eng_paid_amount", formData.eng_paid_amount);
          // }

          // eng_paid_amount
          formDataPayload.append('paid_amount', formData?.paid_amount || 0);
          formDataPayload.append(
            'paid_service_amount',
            formData.paid_service_amount
              ? formData.paid_service_amount.toString()
              : null,
          );
          formDataPayload.append('service_type', formData.service_type);
          formDataPayload.append('repairStatus', formData.repairStatus);
          formDataPayload.append('user_type', userType);

          // Conditional remark fields logic
          if (rejectRemarkOne) {
            formDataPayload.append('rejactRemark', rejectRemarkVal || '');
            formDataPayload.append('eng_remark_1', rejectRemarkOne || '');
            formDataPayload.append('eng_remark_2', remark || '');
          } else if (rejectRemarkVal) {
            formDataPayload.append('rejactRemark', rejectRemarkVal || '');
            formDataPayload.append('eng_remark_1', remark || '');
            formDataPayload.append('eng_remark_2', ''); // Keep eng_remark_2 null
          } else {
            formDataPayload.append('rejactRemark', remark || '');
            formDataPayload.append('eng_remark_1', ''); // Keep eng_remark_1 null
            formDataPayload.append('eng_remark_2', ''); // Keep eng_remark_2 null
          }

          // Append the file, if it exists
          if (formData.uploadFile) {
            formDataPayload.append('uploadFile', formData.uploadFile);
          }

          const response = await axiosInstance.patch(
            `jobcard/update/${jobCardVal}`,
            formDataPayload,
            {
              headers: {
                'Content-Type': 'multipart/form-data',
                Authorization: `Bearer ${token}`,
              },
            },
          );

          if (response.status === 200) {
            Swal.fire({
              title: 'Success',
              text: 'Job Card updated successfully!',
              icon: 'success',
              confirmButtonText: 'OK',
            }).then(() => {
              // navigate("/manage-services/check-warranty");
            });
          }
        } catch (error) {
          console.log(error);

          const errorMessage = error.response?.data?.message;
          console.log(errorMessage, 'errorMessage');

          showErrorAlert({
            title: 'Warning',
            text: errorMessage || 'Something went wrong',
            callback: () => {
              console.log('Error alert confirmed');
            },
          });
        }
      },
    });
  };

  const validateForm = (formData) => {
    const errors = {};
    let isValid = true;

    ComplaintInputs.forEach((field) => {
      if (field.validation?.required) {
        const value = formData[field.name];

        if (value === undefined || value === null || value === '') {
          errors[field.name] = 'This field is required';
          isValid = false;
        } else if (
          field.validation.pattern &&
          !field.validation.pattern.test(value)
        ) {
          errors[field.name] = field.validation.message;
          isValid = false;
        }
      }
    });

    setValidationErrors(errors);
    return isValid;
  };


    const handleUpdateVinNumber = async (formData) => {
    const errors = {};
    let isValid = true;

    ComplaintInputs.forEach((field) => {
      if (field.validation?.required) {
        const value = formData[field.name];

        if (value === undefined || value === null || value === '') {
          errors[field.name] = 'This field is required';
          isValid = false;
        } else if (
          field.validation.pattern &&
          !field.validation.pattern.test(value)
        ) {
          errors[field.name] = field.validation.message;
          isValid = false;
        }
      }
    });

    if (!isValid) {
      setValidationErrors(errors);
      return;
    }
    console.log(formData, 'formData');

    const result = await Swal.fire({
      title: 'Confirmation',
      text: 'Are you sure you want to update this record?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes',
      cancelButtonText: 'No',
      showLoaderOnConfirm: true,
      preConfirm: async () => {
        try {
         const formDataPayload = new FormData();

// 🔹 Basic fields
formDataPayload.append('status', formData.status || 0);
formDataPayload.append('vinNo', formData.vin_no || '');
formDataPayload.append('is_claim', formData.is_claim || '');

// 🔹 Convert comma-separated → array
const serialNosArray = formData.serial_nos_name
  ? formData.serial_nos_name.split(',').map((item) => item.trim())
  : [];

const replacedSerialNosArray = formData.replaced_serial_nos_name
  ? formData.replaced_serial_nos_name.split(',').map((item) => item.trim())
  : [];

// 🔹 Append as array
serialNosArray.forEach((item) => {
  formDataPayload.append('serial_nos_name[]', item);
});

replacedSerialNosArray.forEach((item) => {
  formDataPayload.append('replaced_serial_nos_name[]', item);
});
          // if (userType === "engineeruser") {
          //   formDataPayload.append("engineer_id", engineerId);
          // }
          // if (userType === "businesspartner") {
          //   formDataPayload.append("engineer_id", formData.engineer_id);
          // }
          // if (userType === "businesspartner") {
          //   formDataPayload.append(
          //     "eng_paid_amount",
          //     formData.eng_paid_amount ? formData.eng_paid_amount : null
          //   );
          // }
          // if (userType === "engineeruser") {
          //   formDataPayload.append("eng_paid_amount", formData.eng_paid_amount);
          // }

          // eng_paid_amount
          // formDataPayload.append('paid_amount', formData?.paid_amount || 0);

          // formDataPayload.append(
          //   'paid_service_amount',
          //   formData.paid_service_amount
          //     ? formData.paid_service_amount.toString()
          //     : null,
          // );
          // formDataPayload.append('service_type', formData.service_type);
          // formDataPayload.append('repairStatus', formData.repairStatus);
          // formDataPayload.append('user_type', userType);

          const response = await axiosInstance.post(
            `/jobcard/assign-replace-item-customer`,
            formDataPayload,
            {
              headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`,
              },
            },
          );

          await batteryReplacementSubmit(formData);

          if (response.status === 200) {
            Swal.fire({
              title: 'Success',
              text: 'Job Card updated successfully!',
              icon: 'success',
              confirmButtonText: 'OK',
            }).then(() => {
              // navigate("/manage-services/check-warranty");
              fetchProductList();
              closeModal();
            });
          }
        } catch (error) {
          console.log(error);

          const errorMessage = error.response?.data?.message;
          console.log(errorMessage, 'errorMessage');

          showErrorAlert({
            title: 'Warning',
            text: errorMessage || 'Something went wrong',
            callback: () => {
              console.log('Error alert confirmed');
            },
          });
        }
      },
    });
  };

  const handleUpdate = async (formData) => {
    const errors = {};
    let isValid = true;

    ComplaintInputs.forEach((field) => {
      if (field.validation?.required) {
        const value = formData[field.name];

        if (value === undefined || value === null || value === '') {
          errors[field.name] = 'This field is required';
          isValid = false;
        } else if (
          field.validation.pattern &&
          !field.validation.pattern.test(value)
        ) {
          errors[field.name] = field.validation.message;
          isValid = false;
        }
      }
    });

    if (!isValid) {
      setValidationErrors(errors);
      return;
    }
    console.log(formData, 'formData');

    const result = await Swal.fire({
      title: 'Confirmation',
      text: 'Are you sure you want to update this record?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes',
      cancelButtonText: 'No',
      showLoaderOnConfirm: true,
      preConfirm: async () => {
        try {
          const formDataPayload = new FormData();

          // Append all fields to the FormData object
          formDataPayload.append('status', formData.status);
          formDataPayload.append('is_complated', 1);

          // if (userType === "engineeruser") {
          //   formDataPayload.append("engineer_id", engineerId);
          // }
          // if (userType === "businesspartner") {
          //   formDataPayload.append("engineer_id", formData.engineer_id);
          // }
          // if (userType === "businesspartner") {
          //   formDataPayload.append(
          //     "eng_paid_amount",
          //     formData.eng_paid_amount ? formData.eng_paid_amount : null
          //   );
          // }
          // if (userType === "engineeruser") {
          //   formDataPayload.append("eng_paid_amount", formData.eng_paid_amount);
          // }

          // eng_paid_amount
          formDataPayload.append('paid_amount', formData?.paid_amount || 0);

          formDataPayload.append(
            'paid_service_amount',
            formData.paid_service_amount
              ? formData.paid_service_amount.toString()
              : null,
          );
          formDataPayload.append('service_type', formData.service_type);
          formDataPayload.append('repairStatus', formData.repairStatus);
          formDataPayload.append('user_type', userType);

          // Conditional remark fields logic
          if (rejectRemarkOne) {
            formDataPayload.append('rejactRemark', rejectRemarkVal || '');
            formDataPayload.append('eng_remark_1', rejectRemarkOne || '');
            formDataPayload.append('eng_remark_2', remark || '');
          } else if (rejectRemarkVal) {
            formDataPayload.append('rejactRemark', rejectRemarkVal || '');
            formDataPayload.append('eng_remark_1', remark || '');
            formDataPayload.append('eng_remark_2', ''); // Keep eng_remark_2 null
          } else {
            formDataPayload.append('rejactRemark', remark || '');
            formDataPayload.append('eng_remark_1', ''); // Keep eng_remark_1 null
            formDataPayload.append('eng_remark_2', ''); // Keep eng_remark_2 null
          }

          // Append the file, if it exists
          if (formData.uploadFile) {
            formDataPayload.append('uploadFile', formData.uploadFile);
          }

          const response = await axiosInstance.patch(
            `jobcard/update/${jobCardVal}`,
            formDataPayload,
            {
              headers: {
                'Content-Type': 'multipart/form-data',
                Authorization: `Bearer ${token}`,
              },
            },
          );

          await batteryReplacementSubmit(formData);

          if (response.status === 200) {
            Swal.fire({
              title: 'Success',
              text: 'Job Card updated successfully!',
              icon: 'success',
              confirmButtonText: 'OK',
            }).then(() => {
              // navigate("/manage-services/check-warranty");
              fetchProductList();
              closeModal();
            });
          }
        } catch (error) {
          console.log(error);

          const errorMessage = error.response?.data?.message;
          console.log(errorMessage, 'errorMessage');

          showErrorAlert({
            title: 'Warning',
            text: errorMessage || 'Something went wrong',
            callback: () => {
              console.log('Error alert confirmed');
            },
          });
        }
      },
    });
  };

  // ---------------------------------------------------------------new create form
  // const handleFormSubmit = async (formData) => {
  //   const errors = {};
  //   let isValid = true;

  //   // Validate form fields
  //   CustomerInputs.forEach((field) => {
  //     if (field.validation && field.validation.required) {
  //       if (!formData[field.name]) {
  //         errors[field.name] = "This field is required";
  //         isValid = false;
  //       } else if (
  //         field.required &&
  //         field.validation &&
  //         field.validation.pattern &&
  //         !field.validation.pattern.test(formData[field.name])
  //       ) {
  //         errors[field.name] = field.validation.message;
  //         isValid = false;
  //       }
  //     }
  //   });

  //   // If validation fails, set errors and return
  //   if (!isValid) {
  //     setValidationErrors(errors);
  //     return;
  //   }

  //   const result = await Swal.fire({
  //     title: "Confirmation",
  //     text: "Are you sure you want to update this record?",
  //     icon: "warning",
  //     showCancelButton: true,
  //     confirmButtonText: "Yes",
  //     cancelButtonText: "No",
  //     showLoaderOnConfirm: true,
  //     preConfirm: async () => {
  //       try {
  //         // Create a FormData object to append data
  //         const formDataPayload = new FormData();
  //         formDataPayload.append("inspection_by", "dealer");
  //         formDataPayload.append("transaction_date", formData.transaction_date);
  //         formDataPayload.append("contact_no", formData.contact_no);
  //         formDataPayload.append("registration_no", formData.registration_no);
  //         formDataPayload.append("vin_no", formData.vin_no);
  //         formDataPayload.append("pincode", formData.pincode);
  //         // formDataPayload.append("status", 1);
  //         formDataPayload.append("engineer_id", formData.engineer_id || 0);
  //         formDataPayload.append("remark", formData.remark);
  //         formDataPayload.append("status", formData.status);
  //         formDataPayload.append("is_claim", formData.is_claim);
  //         formDataPayload.append("reqNum", formData.vin_no);
  //         formDataPayload.append("reqType", "V");
  //         formDataPayload.append("service_type", "0");
  //         formDataPayload.append("warrantyFrom", formData?.warrantyFrom || 0);
  //         formDataPayload.append("warrantyTo", formData?.warrantyTo || 0);
  //         formDataPayload.append("claimName", formData?.claimName || 0);
  //         formDataPayload.append("repairStatus", formData?.repairStatus || 0);
  //         formDataPayload.append("kiloMeter", kiloMeterData || 0);
  //         formDataPayload.append("cost", formData?.estCost || 0);

  //         // Append the uploaded file if it exists
  //         if (formData.uploadFile) {
  //           formDataPayload.append("uploadFile", formData.uploadFile);
  //         }

  //         // API request to create the department
  //         const response = await axiosInstance.post(
  //           "jobcard/create",
  //           formDataPayload,
  //           {
  //             headers: {
  //               "Content-Type": "multipart/form-data",
  //               Authorization: `Bearer ${token}`,
  //             },
  //           }
  //         );

  //         if (response.status === 200) {
  //           Swal.fire({
  //             title: "Success",
  //             text: "Job Card added successfully!",
  //             icon: "success",
  //             confirmButtonText: "OK",
  //           }).then(() => {
  //             navigate("/manage-services/check-warranty");
  //           });
  //         }
  //       } catch (error) {
  //         console.log(error);

  //         const errorMessage = error.response?.data?.message;
  //         console.log(errorMessage, "errorMessage");

  //         showErrorAlert({
  //           title: "Warning",
  //           text:
  //             errorMessage ||
  //             "Please check the VIN number, duplicate VIN number found",
  //           callback: () => {
  //             console.log("Error alert confirmed");
  //           },
  //         });
  //       }
  //     },
  //   });

  //   if (!result.isConfirmed) {
  //     // setLoading(false);
  //   }
  // };

  const handleFormSubmit = async () => {
    console.log('clicked');
  };

  const handleClose = () => {
    setOpenCustomerModel(false);
    setFormData({
      Trans_Date: new Date(),
      Allocation_Date: new Date(),
    });
  };

  useEffect(() => {
    if (formData?.model_id) fetchVariantDD();
  }, [formData?.model_id]);

  const fetchVariantDD = async () => {
    try {
      const business_partner_id =
        businessPartnerId == 0 ? 1 : businessPartnerId;
      const response = await axiosInstance.post(
        '/variant/ddlvariant',
        {
          business_partner_id,
          product_id: formData?.product_id,
          model_id: formData?.model_id,
          make_id: formData?.make_id,
          subproduct_id: formData?.subproduct_id,
        },
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
        },
      );

      const options = response.data.data.data.map((data) => ({
        label: data.NAME,
        value: data.ID,
      }));

      setVariantDD(options);
      console.log(options, 'OPTIONS');
    } catch (error) {
      console.error('Error fetching product options:', error);
    }
  };

  useEffect(() => {
    fetchFuelType();
  }, []);

  const fetchFuelType = async () => {
    try {
      const business_partner_id =
        businessPartnerId == 0 ? 1 : businessPartnerId;
      const response = await axiosInstance.post(
        '/fueltype/ddlfueltype',
        {
          business_partner_id,
        },
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
        },
      );

      const options = response.data.data.data.map((data) => ({
        label: data.NAME,
        value: data.ID,
      }));

      setFuelType(options);
      console.log(options, 'OPTIONS');
    } catch (error) {
      console.error('Error fetching product options:', error);
    }
  };

  useEffect(() => {
    fetchColor();
  }, []);

  const fetchColor = async () => {
    try {
      const business_partner_id =
        businessPartnerId == 0 ? 1 : businessPartnerId;
      const response = await axiosInstance.post(
        '/color/ddlcolor',
        {
          business_partner_id,
        },
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
        },
      );

      const options = response.data.data.data.map((data) => ({
        label: data.NAME,
        value: data.ID,
      }));

      setColor(options);
      console.log(options, 'OPTIONS');
    } catch (error) {
      console.error('Error fetching product options:', error);
    }
  };

  useEffect(() => {
    fetchSubproduct();
  }, [formData?.product_id]);

  const fetchSubproduct = async () => {
    try {
      const business_partner_id =
        businessPartnerId == 0 ? 1 : businessPartnerId;
      const response = await axiosInstance.post(
        '/subproduct/ddlsubproduct',
        {
          business_partner_id,
          product_id: formData?.product_id,
        },
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
        },
      );

      const options = response.data.data.data.map((data) => ({
        label: data.NAME,
        value: data.ID,
      }));

      setSubproduct(options);
      console.log(options, 'OPTIONS');
    } catch (error) {
      console.error('Error fetching product options:', error);
    }
  };

  useEffect(() => {
    fetchOccupationOptions();
  }, []);

  const fetchOccupationOptions = async () => {
    try {
      const business_partner_id =
        businessPartnerId == 0 ? 1 : businessPartnerId;
      const response = await axiosInstance.post(
        '/occupation/ddloccupation',
        {
          business_partner_id,
        },
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
        },
      );

      const options = response.data.data.data.map((data) => ({
        label: data.NAME,
        value: data.ID,
      }));

      setOccupationDD(options);
      console.log(options, 'OPTIONS');
    } catch (error) {
      console.error('Error fetching product options:', error);
    }
  };

  useEffect(() => {
    fetchLanguageOptions();
  }, []);

  const fetchLanguageOptions = async () => {
    try {
      const business_partner_id =
        businessPartnerId == 0 ? 1 : businessPartnerId;
      const response = await axiosInstance.post(
        '/language/ddllanguage',
        {
          business_partner_id,
        },
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
        },
      );

      const options = response.data.data.data.map((data) => ({
        label: data.NAME,
        value: data.ID,
      }));

      setLanguageDD(options);
      console.log(options, 'OPTIONS');
    } catch (error) {
      console.error('Error fetching product options:', error);
    }
  };

  useEffect(() => {
    fetchTitleOptions();
  }, []);

  const fetchTitleOptions = async () => {
    try {
      const business_partner_id =
        businessPartnerId == 0 ? 1 : businessPartnerId;
      const response = await axiosInstance.post(
        '/title/ddltitle',
        {
          business_partner_id,
        },
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
        },
      );

      const options = response.data.data.data.map((data) => ({
        label: data.NAME,
        value: data.ID,
      }));

      setTitleDD(options);
      console.log(options, 'OPTIONS');
    } catch (error) {
      console.error('Error fetching product options:', error);
    }
  };

  const TABLE_HEADERS = [
    // "Sr No.",
    // "Product ID",
    'Complaint Name',

    'Dealer Name',
    // "Business Partner ID",
    'Job Card Created Date',
    'Job Card Done Date',
    // "Registration No.",
    'Dealer Trade Date',
    'Vin No.',
    // "Inspect By",
    // "Pin Code",
    // "Job Type",
    'Service Type',
    'Parts/Section to be replaced',
    'Remark',
    // "Engineer Name",
    'Service Charges',
    // "Engineer Paid Amount",
    'Job Status',

    'Action',
  ];

  const keyMapping = {
    // "Sr No.": "Sr No.",
    // "Product ID": "product_id",
    // "Name": "product_name",
    'Complaint Name': 'complaint_name',

    // "Service Type": "service_type",
    // "Variant Name": "variant_name",
    // "Item Name": "item_name",
    // Quantity: "quantity",
    // "Created On": "created_at",
    // "Status": "is_complated ",
    'Parts/Section to be replaced': 'type_of_service',
    'Engineer Name': 'engineer_name',
    'Service Charges': 'paid_amount',
    'Dealer Name': 'dealer_name',
    // "Business Partner ID": "onboard_id",
    'Dealer Trade Date': 'dealer_warrnty_date',
    'Job Card Created Date': 'transaction_date',
    'Job Card Done Date': 'jobcard_done_date',
    'Customer Name': 'customer_name',
    'Registration No.': 'registration_no',
    'Vin No.': 'vin_no',
    'Service Type': 'service_type',
    // "Inspect By":"inspection_by",
    'Vehicle Type': 'product_name',
    'Pin Code': 'pincode',
    'Admin Amount': 'adminAmt',
    'Engineer Paid Amount': 'eng_paid_amount',
    Remark: 'rejactRemark',
    'Job Type': 'jobTypeName',

    'Job Status': 'is_complated',

    Action: [
      {
        type: 'edit',
        icon: editIcon,
        label: 'Edit',
      },
    ],
  };

  useEffect(() => {
    // fetchProductDD()
    fetchProductOptions();
  }, []);

  const fetchProductOptions = async () => {
    try {
      const response = await axiosInstance.post(
        '/product/list',
        {
          orderBy: 'product_id desc',
          page: 0,
          pageSize: 100, // Adjust as needed
        },
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
        },
      );
      const options = response.data.data.data.map((product) => ({
        label: product.product_name,
        value: product.product_id,
      }));

      setProduct(options);
    } catch (error) {
      console.error('Error fetching product options:', error);
    }
  };

  useEffect(() => {
    const productId = formData.product_id;
    if (productId) {
      fetchMakeDD(productId);
      setMake([]);
    }
  }, [formData.product_id, formData?.subproduct_id]);

  useEffect(() => {
    const makeId = formData.make_id;
    const productId = formData.product_id;
    if (productId && makeId) {
      fetchModelDD(makeId, productId);
      setModel([]);
    }
  }, [formData.make_id, formData.product_id, formData?.subproduct_id]);

  const fetchMakeDD = async (productId) => {
    try {
      const business_partner_id =
        businessPartnerId == 0 ? 1 : businessPartnerId;
      const response = await axiosInstance.post(
        '/make/ddlmake',
        {
          business_partner_id,
          product_id: productId,
        },
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
        },
      );
      const fetchedData = response.data.data.data;
      const makedata = fetchedData.map((dropdown) => ({
        value: dropdown.ID,
        label: dropdown.NAME,
      }));
      setMake(makedata);
    } catch (error) {
      console.log(error, 'error');
    }
  };

  const fetchModelDD = async (makeId, productId) => {
    try {
      const business_partner_id =
        businessPartnerId == 0 ? 1 : businessPartnerId;
      const response = await axiosInstance.post(
        '/model/ddlmodel',
        {
          business_partner_id,
          product_id: productId,
          make_id: makeId,
        },
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
        },
      );
      const fetchedData = response.data.data.data;
      const modeldata = fetchedData.map((dropdown) => ({
        value: dropdown.ID,
        label: dropdown.NAME,
      }));
      setModel(modeldata);
    } catch (error) {
      console.log(error, 'error');
    }
  };

  // const Variantlist = async () => {
  //   try {
  //     const response = await axiosInstance.post(
  //       "/jobcard/listdynamicjobcard",
  //       {
  //         business_partner_id: businessPartnerId==0?1:businessPartnerId,
  //         FilterId: formData?.Customer_Name,
  //         FilterString: null,
  //         FilterString1: null,
  //         Type: "JobCardVariantSelection",
  //       },
  //       {
  //         headers: {
  //           "Content-Type": "application/json",
  //           Authorization: `Bearer ${token}`,
  //         },
  //       }
  //     );
  //     if (response?.status) {
  //       if (response?.data?.data?.length > 0) {
  //         setVeriantListData(response?.data?.data || []);
  //         if (!jobCardDataDetails?.job_card_id) {
  //           setVeriantListShow(true);
  //         }
  //       }
  //     }
  //     const vehicleId = response?.data?.data?.[0]?.customer_vehicle_detail_id;
  //     setCustomerVehicleId(vehicleId);
  //     console.log(vehicleId, "VehicleId");
  //   } catch (error) {
  //     console.error("Error fetching business partners:", error);
  //   }
  // };

  const ModalInputs = [
    {
      name: 'service_type',
      placeholder: 'Enter',
      type: 'radio',
      options: [
        { value: 0, label: 'Free Service' },
        { value: 1, label: 'Paid Service' },
        // { value: 2, label: "Within Warranty" },
      ],
      required: true,
      gridClass: 'col-lg-12',
    },
    ...((userType === 'engineeruser' || userType === 'businesspartner') &&
    (formData.service_type === '1' || formData.service_type === 1)
      ? [
          // {
          //   name: "paid_service_amount",
          //   label: "Amount",
          //   placeholder: "Enter Amount",
          //   type: "number",
          //   gridClass: "col-lg-4",
          //   disabled: userType === "engineeruser",
          // },
          ...(userType === 'engineeruser'
            ? [
                {
                  name: 'eng_paid_amount',
                  label: 'Engineer Amount',
                  placeholder: 'Enter Engineer Amount',
                  type: 'number',
                  gridClass: 'col-lg-4',
                },
              ]
            : []),
        ]
      : []),
  ];

  useEffect(() => {
    setFormData((pre) => ({
      ...pre,
      paid_service_amount: paidAmount,
    }));
  }, [isModalOpen]);

  // paidAmount
  // const CustomerInputs = [
  //   // {
  //   //   name: "Customer_Name",
  //   //   label: "Customer Name",
  //   //   type: "dropdown",
  //   //   required: true,
  //   //   // options: options,
  //   //   options: customerList,
  //   //   gridClass: "col-lg-4",
  //   //   validation: { required: true },
  //   //   iscustomer: !jobCardDataDetails?.job_card_id ?true :false,
  //   //   disabled: !jobCardDataDetails?.job_card_id ? false : true,
  //   // },
  //   {
  //     name: "Job_Card_Number",
  //     label: "Job Card Number",
  //     placeholder: "Job Card Number",
  //     type: "text",
  //     Placeholder: "Enter Job_Card_Number",
  //     // value:'reteyey',
  //     required: false,
  //     gridClass: "col-lg-4",
  //     validation: {
  //       required: false,
  //       pattern: /^[A-Za-z0-9 ]*$/,
  //       message: "Only alphabets and digits are allowed",
  //     },
  //     disabled: true,
  //   },
  //   {
  //     name: "transaction_date",
  //     label: "Job Card Date",
  //     placeholder: "Trans. Date",
  //     type: "date",
  //     required: true,
  //     gridClass: "col-lg-4",
  //     validation: { required: true },
  //     disabled: true,
  //   },
  //   // {
  //   //   name: "Job_Type",
  //   //   label: "Job Type",
  //   //   placeholder: "Job Type",
  //   //   type: "dropdown",
  //   //   options: jobCardType || [],
  //   //   required: true,
  //   //   gridClass: "col-lg-4",
  //   //   validation: { required: true },
  //   //   disabled: !jobCardDataDetails?.job_card_id ? false : true,
  //   // },
  //   {
  //     name: "contact_no",
  //     label: "Mobile No.",
  //     placeholder:"Mobile No.",
  //     type: "text",
  //     required: true,
  //     gridClass: "col-lg-4",
  //     validation: {
  //       required: true, pattern: /^[6-9]/ ,
  //       minLength:10,
  //       maxLength:10,
  //       message1: "Contact no should start with 6, 7, 8, 9",
  //       message: "Please enter a valid 10-digit",
  //     },
  //   },
  //   {
  //     name: "registration_no",
  //     label: "Registration Number",
  //     type: "text",
  //     // required: true,
  //     gridClass: "col-lg-4",
  //     placeholder: "Enter Registration No.",
  //     // validation: { required: true,maxLength:12,
  //     //   minLength:9,
  //     //   pattern: /^[A-Za-z0-9]{10,12}$/,
  //     //   message: "Registration number must be exactly 12 alphanumeric characters.",
  //     //  },
  //     // disabled: true,
  //   },
  //   {
  //     name: "vin_no",
  //     label: "VIN No.",
  //     placeholder: "Enter Vin No.",
  //     type: "text",
  //     required: true,
  //     gridClass: "col-lg-4",
  //     validation: { required: true,
  //       required: true,
  //       maxLength:20,
  //      },
  //     // disabled: true,
  //   },
  //   {
  //     name: "pincode",
  //     label: "Pin Code",
  //     placeholder: "Enter Pin Code",
  //     type: "text",
  //     required: true,
  //     gridClass: "col-lg-4",
  //     validation: { required: true,
  //        maxLength: 6
  //       },
  //   },
  //   // ...(userType !== "dealeruser"
  //   //   ? [
  //       // {
  //       //   name: "inspection_by",
  //       //   label: "Inspection By",
  //       //   type: "dropdown",
  //       //   required: true,
  //       //   validation: { required: true },
  //       //   // options: options,
  //       //   options: [
  //       //     { label: "dealer", value: "dealer" },
  //       //   ],
  //       //   gridClass: "col-lg-4",
  //       //   validation: { required: true },
  //       //   // iscustomer: !jobCardDataDetails?.job_card_id ?true :false,
  //       //   // disabled: !jobCardDataDetails?.job_card_id ? false : true,
  //       // },
  //     //   {
  //     //     name: "engineer_id",
  //     //     label: "Assign To",
  //     //     placeholder: "Job Type",
  //     //     type: "dropdown",
  //     //     options: engineerOptions ,
  //     //     required: true,
  //     //     gridClass: "col-lg-4",
  //     //     validation: { required: true },
  //     //   },
  //     //   ]
  //     // : []),
  //     {
  //       // name: "reqNumber",
  //       name:"vin_no",
  //       label: "Enter Vin No.",
  //       type: "servicetext",
  //       required: true,
  //       placeholder: "Enter",
  //       isComplaint: true,
  //       gridClass: "col-lg-4",
  //     },
  //     ...(kiloMeterData === null || kiloMeterData === ""
  //       ? [
  //           {
  //             name: "warrantyFrom",
  //             label: "Warranty From",
  //             placeholder: "Trans. Date",
  //             type: "date",
  //             gridClass: "col-lg-4",
  //             disabled: true,
  //           },
  //           {
  //             name: "warrantyTo",
  //             label: "Warranty To",
  //             placeholder: "Trans. Date",
  //             type: "date",
  //             gridClass: "col-lg-4",
  //             disabled: true,
  //           },
  //         ]
  //       : [
  //           {
  //             name: "kiloMeter",
  //             label: "Kilometer",
  //             type: "text",
  //             placeholder: "Kilometer",
  //             validation: { required: true },
  //             required: true,
  //             gridClass: "col-lg-4",
  //           },
  //         ]),
  //     {
  //       name: "remainingdays",
  //       label: "Remaining Days",
  //       type: "text",
  //       placeholder: "Days",
  //       disabled: true,
  //       gridClass: "col-lg-4",
  //     },
  //     {
  //       name: "claimName",
  //       label: "Complain Name",
  //       type: "text",
  //       placeholder: "Enter Description",
  //       validation: { required: true },
  //       required: true,
  //       gridClass: "col-lg-4",
  //     },
  //     {
  //       name: "remark",
  //       label: "Remark",
  //       type: "text",
  //       placeholder: "Enter Description",
  //       validation: { required: true },
  //       required: true,
  //       gridClass: "col-lg-4",
  //     },
  //     {
  //       name: "status",
  //       label: "Status",
  //       type: "dropdown",
  //       // required: true,
  //       placeholder: "Select Complaint",
  //       options: [
  //         { label: "Pending", value: 0 },
  //         { label: "Done", value: 1 },
  //       ],
  //       gridClass: "col-lg-4",
  //     },

  //     // remainingdays: remainingDays < 0 ? "0.00" : remainingDays,
  //     {
  //       name: "is_claim",
  //       label: "Is Claim",
  //       type: "dropdown",
  //       required: true,
  //       placeholder: "Select",
  //       options: [
  //         { label: "Yes", value: 1 },
  //         { label: "No", value: 0 },
  //       ],
  //       disabled: remainingDaysVal < 0 ? true : false || userType === "engineeruser" ,
  //       gridClass: "col-lg-4",
  //     },
  //     // {
  //     //   name: "engineer_id",
  //     //   label: "Assign To",
  //     //   placeholder: "Job Type",
  //     //   type: "dropdown",
  //     //   options: engineerOptions ,
  //     //   required: true,
  //     //   gridClass: "col-lg-4",
  //     //   validation: { required: true },
  //     // },
  //     ...(userType === "businesspartner"
  //     ? [
  //       {
  //         name: "engineer_id",
  //         label: "Assign To",
  //         placeholder: "Job Type",
  //         type: "dropdown",
  //         options: engineerOptions ,
  //         required: true,
  //         gridClass: "col-lg-4",
  //         validation: { required: true },
  //       },
  //       ]
  //     : []),
  //     ...( userType ===  "engineeruser"
  //     ? [
  //       {
  //         name: "repairStatus",
  //         label: "Repair Status",
  //         type: "dropdown",
  //         required: true,
  //         placeholder: "Select Complaint",

  //         options: [
  //           { label: "Repairable", value: "Repairable" },
  //           { label: "Replace New One", value: "Replace New One" },,
  //         ],

  //         gridClass: "col-lg-4",
  //       },
  //       ]
  //     : []),
  //     {
  //       name: "uploadFile",
  //       label: "Reference Photo",
  //       type: "file",
  //       // required: true,
  //       gridClass: "col-lg-4",
  //       // validation: { required: true },
  //     },
  // ];

  // const CustomerInputs = [
  //   // {
  //   //   name: "Customer_Name",
  //   //   label: "Customer Name",
  //   //   type: "dropdown",
  //   //   required: true,
  //   //   // options: options,
  //   //   options: customerList,
  //   //   gridClass: "col-lg-4",
  //   //   validation: { required: true },
  //   //   iscustomer: !jobCardDataDetails?.job_card_id ?true :false,
  //   //   disabled: !jobCardDataDetails?.job_card_id ? false : true,
  //   // },
  //   {
  //     name: "Job_Card_Number",
  //     label: "Job Card Number",
  //     placeholder: "Job Card Number",
  //     type: "text",
  //     Placeholder: "Enter Job_Card_Number",
  //     // value:'reteyey',
  //     required: false,
  //     gridClass: "col-lg-4",
  //     validation: {
  //       required: false,
  //       pattern: /^[A-Za-z0-9 ]*$/,
  //       message: "Only alphabets and digits are allowed",
  //     },
  //     disabled: true,
  //   },
  //   {
  //     name: "transaction_date",
  //     label: "Job Card Date",
  //     placeholder: "Trans. Date",
  //     type: "date",
  //     required: true,
  //     gridClass: "col-lg-4",
  //     validation: { required: true },
  //     disabled: true,
  //   },
  //   // {
  //   //   // name: "reqNumber",
  //   //   name: "dealer_name",
  //   //   label: "Enter Dealer Name",
  //   //   type: "text",
  //   //   required: true,
  //   //   placeholder: "Enter",
  //   //   // isComplaint: true,
  //   //   gridClass: "col-lg-4",
  //   // },

  //   ...(userType === "businesspartner"
  //     ? [
  //         {
  //           // name: "reqNumber",
  //           name: "dealer_name",
  //           label: "Enter Dealer Name",
  //           type: "text",
  //           required: true,
  //           placeholder: "Enter",
  //           // isComplaint: true,
  //           gridClass: "col-lg-4",
  //           disabled: true,
  //         },
  //       ]
  //     : []),
  //   // {
  //   //   name: "Job_Type",
  //   //   label: "Job Type",
  //   //   placeholder: "Job Type",
  //   //   type: "dropdown",
  //   //   options: jobCardType || [],
  //   //   required: true,
  //   //   gridClass: "col-lg-4",
  //   //   validation: { required: true },
  //   //   disabled: !jobCardDataDetails?.job_card_id ? false : true,
  //   // },
  //   {
  //     name: "contact_no",
  //     label: "Mobile No.",
  //     placeholder: "Mobile No.",
  //     type: "text",
  //     required: true,
  //     gridClass: "col-lg-4",
  //     validation: {
  //       required: true,
  //       pattern: /^[6-9]/,
  //       minLength: 10,
  //       maxLength: 10,
  //       message1: "Contact no should start with 6, 7, 8, 9",
  //       message: "Please enter a valid 10-digit",
  //     },
  //   },
  //   {
  //     name: "registration_no",
  //     label: "Registration Number",
  //     type: "text",
  //     // required: true,
  //     gridClass: "col-lg-4",
  //     placeholder: "Enter Registration No.",
  //     // validation: { required: true,maxLength:12,
  //     //   minLength:9,
  //     //   pattern: /^[A-Za-z0-9]{10,12}$/,
  //     //   message: "Registration number must be exactly 12 alphanumeric characters.",
  //     //  },
  //     // disabled: true,
  //   },
  //   {
  //     name: "vin_no",
  //     label: "VIN No.",
  //     placeholder: "Enter Vin No.",
  //     type: "text",
  //     required: true,
  //     gridClass: "col-lg-4",
  //     validation: {
  //       required: true,
  //       required: true,
  //       maxLength: 20,
  //     },
  //     // disabled: true,
  //   },
  //   {
  //     name: "pincode",
  //     label: "Pin Code",
  //     placeholder: "Enter Pin Code",
  //     type: "text",
  //     required: true,
  //     gridClass: "col-lg-4",
  //     validation: {
  //       required: true,
  //       maxLength: 6,
  //     },
  //   },
  //   {
  //     // name: "reqNumber",
  //     name: "vin_no",
  //     label: "Enter Vin No.",
  //     type: "servicetext",
  //     required: true,
  //     placeholder: "Enter",
  //     isComplaint: true,
  //     gridClass: "col-lg-4",
  //   },
  //   ...(kiloMeterData === null || kiloMeterData === ""
  //     ? [
  //         {
  //           name: "warrantyFrom",
  //           label: "Vehicle Warranty From",
  //           placeholder: "Trans. Date",
  //           type: "date",
  //           gridClass: "col-lg-4",
  //           disabled: true,
  //         },
  //         {
  //           name: "warrantyTo",
  //           label: "Vehicle Warranty To",
  //           placeholder: "Trans. Date",
  //           type: "date",
  //           gridClass: "col-lg-4",
  //           disabled: true,
  //         },
  //       ]
  //     : [
  //         {
  //           name: "kiloMeter",
  //           label: "Kilometer",
  //           type: "text",
  //           placeholder: "Kilometer",
  //           validation: { required: true },
  //           required: true,
  //           gridClass: "col-lg-4",
  //         },
  //       ]),
  //   {
  //     name: "remainingdays",
  //     label: "Remaining Days",
  //     type: "text",
  //     placeholder: "Days",
  //     disabled: true,
  //     gridClass: "col-lg-4",
  //   },
  //   {
  //     name: "batteryWarrntyFrom",
  //     label: "Battery Warranty From",
  //     placeholder: "Trans. Date",
  //     type: "date",
  //     gridClass: "col-lg-4",
  //     disabled: true,
  //   },
  //   {
  //     name: "batteryWarrntyTo",
  //     label: "Battery Warranty To",
  //     placeholder: "Trans. Date",
  //     type: "date",
  //     gridClass: "col-lg-4",
  //     disabled: true,
  //   },
  //   {
  //     name: "btryremaining_days",
  //     label: "Battery Remaining Days",
  //     type: "text",
  //     placeholder: "Days",
  //     disabled: true,
  //     gridClass: "col-lg-4",
  //   },
  //   {
  //     name: "cntrlwarrantyFrom",
  //     label: "Controller Warranty From",
  //     placeholder: "Trans. Date",
  //     type: "date",
  //     gridClass: "col-lg-4",
  //     disabled: true,
  //   },
  //   {
  //     name: "cntrlwarrantyTo",
  //     label: "Controller Warranty To",
  //     placeholder: "Trans. Date",
  //     type: "date",
  //     gridClass: "col-lg-4",
  //     disabled: true,
  //   },
  //   {
  //     name: "cntrlremaining_days",
  //     label: "Controller Remaining Days",
  //     type: "text",
  //     placeholder: "Days",
  //     disabled: true,
  //     gridClass: "col-lg-4",
  //   },
  //   {
  //     name: "mtrwarrantyFrom",
  //     label: "Motor Warranty From",
  //     placeholder: "Trans. Date",
  //     type: "date",
  //     gridClass: "col-lg-4",
  //     disabled: true,
  //   },
  //   {
  //     name: "mtrwarrantyTo",
  //     label: "Motor Warranty To",
  //     placeholder: "Trans. Date",
  //     type: "date",
  //     gridClass: "col-lg-4",
  //     disabled: true,
  //   },
  //   {
  //     name: "mtrremaining_days",
  //     label: "Motor Remaining Days",
  //     type: "text",
  //     placeholder: "Days",
  //     disabled: true,
  //     gridClass: "col-lg-4",
  //   },
  //   // {
  //   //   name: "chrgrwarrantyFrom",
  //   //   label: "Charger Warranty From",
  //   //   placeholder: "Trans. Date",
  //   //   type: "date",
  //   //   gridClass: "col-lg-4",
  //   //   disabled: true,
  //   // },
  //   // {
  //   //   name: "chrgrwarrantyTo",
  //   //   label: "Charger Warranty To",
  //   //   placeholder: "Trans. Date",
  //   //   type: "date",
  //   //   gridClass: "col-lg-4",
  //   //   disabled: true,
  //   // },
  //   // {
  //   //   name: "chrgrremaining_days",
  //   //   label: "Charger Remaining Days",
  //   //   type: "text",
  //   //   placeholder: "Days",
  //   //   disabled: true,
  //   //   gridClass: "col-lg-4",
  //   // },
  //   {
  //     name: "covrtwarrantyFrom",
  //     label: "Converter Warranty From",
  //     placeholder: "Trans. Date",
  //     type: "date",
  //     gridClass: "col-lg-4",
  //     disabled: true,
  //   },
  //   {
  //     name: "covrtwarrantyTo",
  //     label: "Converter Warranty To",
  //     placeholder: "Trans. Date",
  //     type: "date",
  //     gridClass: "col-lg-4",
  //     disabled: true,
  //   },
  //   {
  //     name: "covrtremaining_days",
  //     label: "Converter Remaining Days",
  //     type: "text",
  //     placeholder: "Days",
  //     disabled: true,
  //     gridClass: "col-lg-4",
  //   },
  //   {
  //     name: "tradeDate",
  //     label: "Dealer Trade Date",
  //     type: "date",
  //     placeholder: "Days",
  //     disabled: true,
  //     gridClass: "col-lg-4",
  //   },
  //   {
  //     name: "claimName",
  //     label: "Customer Name",
  //     type: "text",
  //     placeholder: "Enter Description",
  //     validation: { required: true },
  //     required: true,
  //     gridClass: "col-lg-4",
  //   },
  //   {
  //     name: "remark",
  //     label: "Remark",
  //     type: "text",
  //     placeholder: "Enter Description",
  //     validation: { required: true },
  //     required: true,
  //     gridClass: "col-lg-4",
  //   },
  //   {
  //     name: "status",
  //     label: "Status",
  //     type: "dropdown",
  //     required: true,
  //     placeholder: "Select Complaint",
  //     options: [
  //       { label: "Pending", value: 0 },
  //       { label: "Done", value: 1 },
  //       { label: "Reject", value: 2 },
  //     ],
  //     gridClass: "col-lg-4",
  //   },
  //   {
  //     name: "type_of_service",
  //     label: "Part/Section to be Replaced",
  //     type: "dropdown",
  //     required: true,
  //     placeholder: "Select Complaint",
  //     options: [
  //       { label: "Vehicle", value: 0 },
  //       { label: "Motor", value: 1 },
  //       { label: "Controller", value: 2 },
  //       { label: "Battery", value: 3 },
  //       { label: "Converter", value: 4 },
  //     ],
  //     gridClass: "col-lg-4",
  //   },
  //   // {
  //   //   name: "service_type",
  //   //   label: "Service Type",
  //   //   type: "dropdown",
  //   //   required: true,
  //   //   placeholder: "Select Complaint",
  //   //   // disabled: remainingDaysVal === 1 || remainingDaysVal <= 0 ? true : false ,
  //   //   // disabled: Object.values(remainingDaysVal).some(days => days <= 1) ? true : false,
  //   //   options: [
  //   //     { label: "Free Service", value: 0 },
  //   //     { label: "Paid Service", value: 1 },
  //   //     { label: "Within Warranty", value: 2 },
  //   //   ],
  //   //   gridClass: "col-lg-4",
  //   // },
  //   {
  //     name: "service_type",
  //     label: "Service Type",
  //     type: "dropdown",
  //     required: true,
  //     placeholder: "Select Complaint",
  //     options: [
  //       // ...(formData.type_of_service === 0
  //       //   ? [
  //       //     { label: "Free Service", value: 0 }, // Show this only for type_of_service === 0
  //       //   ]
  //       //   : []),
  //       { label: "Free Service", value: 0 },
  //       { label: "Paid Service", value: 1 },
  //       { label: "Within Warranty", value: 2 },
  //     ],
  //     gridClass: "col-lg-4",
  //   },

  //   ...(formData.service_type !== 1
  // ? [
  //     {
  //       name: "paid_amount",
  //       label: "Service Charges",
  //       type: "text",
  //       placeholder: "Enter Service Charges",
  //       gridClass: "col-lg-4",
  //     },
  //   ]
  // : []),
  //   // {
  //   //   name: "paid_amount",
  //   //   label: "Service Charges",
  //   //   type: "text",
  //   //   placeholder: "Enter Service Charges",
  //   //   // validation: { required: true },
  //   //   // required: true,
  //   //   gridClass: "col-lg-4",
  //   // },
  //   // remainingdays: remainingDays < 0 ? "0.00" : remainingDays,
  //   {
  //     name: "is_claim",
  //     label: "Warranty Claim",
  //     type: "dropdown",
  //     required: true,
  //     placeholder: "Select",
  //     options: [
  //       { label: "Yes", value: "1" },
  //       { label: "No", value: "0" },
  //     ],
  //     // disabled: remainingDaysVal <= 1  ? true : false ,
  //     // disabled: Object.values(remainingDaysVal).some(days => days <= 1) ? true : false,
  //     disabled:
  //       formData.type_of_service !== undefined &&
  //       ((formData.type_of_service === 0 &&
  //         remainingDaysVal.remainingDays <= 0) ||
  //         (formData.type_of_service === 1 &&
  //           remainingDaysVal.mtrremaining_days <= 0) ||
  //         (formData.type_of_service === 2 &&
  //           remainingDaysVal.cntrlremaining_days <= 0) ||
  //         (formData.type_of_service === 3 &&
  //           remainingDaysVal.btryremaining_days <= 0) ||
  //         (formData.type_of_service === 4 &&
  //           remainingDaysVal.covrtremaining_days <= 0)),
  //     gridClass: "col-lg-4",
  //   },
  //   // ...(userType === "businesspartner"
  //   //   ? [
  //   //     {
  //   //       name: "engineer_id",
  //   //       label: "Assign To",
  //   //       placeholder: "Job Type",
  //   //       type: "dropdown",
  //   //       options: engineerOptions,
  //   //       required: true,
  //   //       gridClass: "col-lg-4",
  //   //       validation: { required: true },
  //   //     },
  //   //   ]
  //   //   : []),
  //   ...(userType === "engineeruser"
  //     ? [
  //         {
  //           name: "repairStatus",
  //           label: "Repair Status",
  //           type: "dropdown",
  //           required: true,
  //           placeholder: "Select Complaint",

  //           options: [
  //             { label: "Repairable", value: "Repairable" },
  //             { label: "Replace New One", value: "Replace New One" },
  //             ,
  //           ],

  //           gridClass: "col-lg-4",
  //         },
  //       ]
  //     : []),

  //   {
  //     name: "uploadFile",
  //     label: "Reference Photo",
  //     type: "file",
  //     // required: true,
  //     gridClass: "col-lg-4",
  //     // validation: { required: true },
  //   },
  // ];

  const CustomerInputs = [
    // {
    //   name: "Customer_Name",
    //   label: "Customer Name",
    //   type: "dropdown",
    //   required: true,
    //   // options: options,
    //   options: customerList,
    //   gridClass: "col-lg-4",
    //   validation: { required: true },
    //   iscustomer: !jobCardDataDetails?.job_card_id ?true :false,
    //   disabled: !jobCardDataDetails?.job_card_id ? false : true,
    // },
    {
      name: 'Job_Card_Number',
      label: 'Job Card Number',
      placeholder: 'Job Card Number',
      type: 'text',
      Placeholder: 'Enter Job_Card_Number',
      // value:'reteyey',
      required: false,
      gridClass: 'col-lg-4',
      validation: {
        required: false,
        pattern: /^[A-Za-z0-9 ]*$/,
        message: 'Only alphabets and digits are allowed',
      },
      disabled: true,
    },
    {
      name: 'transaction_date',
      label: 'Job Card Date',
      placeholder: 'Trans. Date',
      type: 'date',
      required: true,
      gridClass: 'col-lg-4',
      validation: { required: true },
      disabled: true,
    },
    ...(userType === 'businesspartner'
      ? [
          {
            name: 'dealer_name',
            label: 'Dealer Name',
            type: 'text',
            // required: true,
            gridClass: 'col-lg-4',
            placeholder: 'Enter Dealer Name',
            // validation: { required: true,maxLength:12,
            //   minLength:9,
            //   pattern: /^[A-Za-z0-9]{10,12}$/,
            //   message: "Registration number must be exactly 12 alphanumeric characters.",
            //  },
            // disabled: true,
          },
        ]
      : []),
    // {
    //   name: "dealer_name",
    //   label: "Dealer Name",
    //   type: "text",
    //   // required: true,
    //   gridClass: "col-lg-4",
    //   placeholder: "Enter Dealer Name",
    //   // validation: { required: true,maxLength:12,
    //   //   minLength:9,
    //   //   pattern: /^[A-Za-z0-9]{10,12}$/,
    //   //   message: "Registration number must be exactly 12 alphanumeric characters.",
    //   //  },
    //   // disabled: true,
    // },
    // {
    //   name: "Job_Type",
    //   label: "Job Type",
    //   placeholder: "Job Type",
    //   type: "dropdown",
    //   options: jobCardType || [],
    //   required: true,
    //   gridClass: "col-lg-4",
    //   validation: { required: true },
    //   disabled: !jobCardDataDetails?.job_card_id ? false : true,
    // },
    {
      name: 'contact_no',
      label: 'Mobile No.',
      placeholder: 'Mobile No.',
      type: 'text',
      // required: true,
      gridClass: 'col-lg-4',
      validation: {
        required: false,
        pattern: /^[6-9]/,
        minLength: 10,
        maxLength: 10,
        message1: 'Contact no should start with 6, 7, 8, 9',
        message: 'Please enter a valid 10-digit',
      },
      disabled: true,
    },
    {
      name: 'registration_no',
      label: 'Registration Number',
      type: 'text',
      // required: true,
      gridClass: 'col-lg-4',
      placeholder: 'Enter Registration No.',
      // validation: { required: true,maxLength:12,
      //   minLength:9,
      //   pattern: /^[A-Za-z0-9]{10,12}$/,
      //   message: "Registration number must be exactly 12 alphanumeric characters.",
      //  },
      // disabled: true,
    },
    {
      name: 'vin_no',
      label: 'VIN No.',
      placeholder: 'Enter Vin No.',
      type: 'text',
      required: true,
      gridClass: 'col-lg-4',
      validation: { required: true, required: true, maxLength: 20 },
      disabled: true,
    },
    {
      name: 'address',
      label: 'Address',
      placeholder: 'Enter Address',
      type: 'text',
      // required: true,
      gridClass: 'col-lg-4',
      // validation: { required: true, maxLength: 6 },
      disabled: true,
    },
    {
      name: 'email',
      label: 'Email Id',
      placeholder: 'Enter Email ID',
      type: 'text',
      // required: true,
      gridClass: 'col-lg-4',
      // validation: { required: true, maxLength: 6 },
      disabled: true,
    },
    {
      name: 'pincode',
      label: 'Pin Code',
      placeholder: 'Enter Pin Code',
      type: 'text',
      required: true,
      gridClass: 'col-lg-4',
      validation: { required: true, maxLength: 6 },
      disabled: true,
    },
    // ...(userType !== "dealeruser"
    //   ? [
    //     {
    //       name: "engineer_id",
    //       label: "Assign To",
    //       placeholder: "Job Type",
    //       type: "dropdown",
    //       options: engineerOptions ,
    //       required: true,
    //       gridClass: "col-lg-4",
    //       validation: { required: true },
    //     },
    //     ]
    //   : []),
    {
      // name: "reqNumber",
      name: 'vin_no',
      label: 'Enter Vin No.',
      type: 'servicetext',
      required: true,
      placeholder: 'Enter',
      isComplaint: true,
      gridClass: 'col-lg-4',
      disabled: true,
    },
    ...(kiloMeterData === null || kiloMeterData === ''
      ? [
          {
            name: 'warrantyFrom',
            label: 'Vehicle Warranty From',
            placeholder: 'Trans. Date',
            type: 'date',
            gridClass: 'col-lg-4',
            disabled: true,
          },
          {
            name: 'warrantyTo',
            label: 'Vehicle Warranty To',
            placeholder: 'Trans. Date',
            type: 'date',
            gridClass: 'col-lg-4',
            disabled: true,
          },
        ]
      : [
          {
            name: 'kiloMeter',
            label: 'Kilometer',
            type: 'text',
            placeholder: 'Kilometer',
            validation: { required: true },
            required: true,
            gridClass: 'col-lg-4',
          },
        ]),
    {
      name: 'remainingdays',
      label: 'Remaining Days',
      type: 'text',
      placeholder: 'Days',
      disabled: true,
      gridClass: 'col-lg-4',
    },
    {
      name: 'batteryWarrntyFrom',
      label: 'Battery Warranty From',
      placeholder: 'Trans. Date',
      type: 'date',
      gridClass: 'col-lg-4',
      disabled: true,
    },
    {
      name: 'batteryWarrntyTo',
      label: 'Battery Warranty To',
      placeholder: 'Trans. Date',
      type: 'date',
      gridClass: 'col-lg-4',
      disabled: true,
    },
    {
      name: 'btryremaining_days',
      label: 'Battery Remaining Days',
      type: 'text',
      placeholder: 'Days',
      disabled: true,
      gridClass: 'col-lg-4',
    },
    {
      name: 'batteryReplacementRemaining_days',
      label: 'Battery Replacement Remaining Days',
      type: 'text',
      placeholder: 'Days',
      disabled: true,
      gridClass: 'col-lg-4',
    },
    {
      name: 'cntrlwarrantyFrom',
      label: 'Controller Warranty From',
      placeholder: 'Trans. Date',
      type: 'date',
      gridClass: 'col-lg-4',
      disabled: true,
    },
    {
      name: 'cntrlwarrantyTo',
      label: 'Controller Warranty To',
      placeholder: 'Trans. Date',
      type: 'date',
      gridClass: 'col-lg-4',
      disabled: true,
    },
    {
      name: 'cntrlremaining_days',
      label: 'Controller Remaining Days',
      type: 'text',
      placeholder: 'Days',
      disabled: true,
      gridClass: 'col-lg-4',
    },
    {
      name: 'mtrwarrantyFrom',
      label: 'Motor Warranty From',
      placeholder: 'Trans. Date',
      type: 'date',
      gridClass: 'col-lg-4',
      disabled: true,
    },
    {
      name: 'mtrwarrantyTo',
      label: 'Motor Warranty To',
      placeholder: 'Trans. Date',
      type: 'date',
      gridClass: 'col-lg-4',
      disabled: true,
    },
    {
      name: 'mtrremaining_days',
      label: 'Motor Remaining Days',
      type: 'text',
      placeholder: 'Days',
      disabled: true,
      gridClass: 'col-lg-4',
    },
    {
      name: 'motorReplacementRemaining_days',
      label: 'Motor Replacement Remaining Days',
      type: 'text',
      placeholder: 'Days',
      disabled: true,
      gridClass: 'col-lg-4',
    },
    // {
    //   name: "chrgrwarrantyFrom",
    //   label: "Charger Warranty From",
    //   placeholder: "Trans. Date",
    //   type: "date",
    //   gridClass: "col-lg-4",
    //   disabled: true,
    // },
    // {
    //   name: "chrgrwarrantyTo",
    //   label: "Charger Warranty To",
    //   placeholder: "Trans. Date",
    //   type: "date",
    //   gridClass: "col-lg-4",
    //   disabled: true,
    // },
    // {
    //   name: "chrgrremaining_days",
    //   label: "Charger Remaining Days",
    //   type: "text",
    //   placeholder: "Days",
    //   disabled: true,
    //   gridClass: "col-lg-4",
    // },
    {
      name: 'covrtwarrantyFrom',
      label: 'Converter Warranty From',
      placeholder: 'Trans. Date',
      type: 'date',
      gridClass: 'col-lg-4',
      disabled: true,
    },
    {
      name: 'covrtwarrantyTo',
      label: 'Converter Warranty To',
      placeholder: 'Trans. Date',
      type: 'date',
      gridClass: 'col-lg-4',
      disabled: true,
    },
    {
      name: 'covrtremaining_days',
      label: 'Converter Remaining Days',
      type: 'text',
      placeholder: 'Days',
      disabled: true,
      gridClass: 'col-lg-4',
    },
    {
      name: 'tradeDate',
      label: 'Dealer Trade Date',
      type: 'date',
      placeholder: 'Days',
      disabled: true,
      gridClass: 'col-lg-4',
    },
    {
      name: 'claimName',
      label: 'Customer Name',
      type: 'text',
      placeholder: 'Enter Customer Name',
      // validation: { required: true },
      // required: true,
      gridClass: 'col-lg-4',
    },
    //   {
    //     name: "remark",
    //     label: "Complain Details",
    //     type: "text",
    //     placeholder: "Enter Description",
    //     validation: { required: true },
    //     required: true,
    //     gridClass: "col-lg-4",
    //   },
    // {
    //   name: "status",
    //   label: "Status",
    //   type: "dropdown",
    //   required: true,
    //   placeholder: "Select Complaint",
    //   options: [
    //     { label: "Pending", value: 0 },
    //     { label: "Done", value: 1 },
    //   ],
    //   gridClass: "col-lg-4",
    // },
    //   {
    //     name: "type_of_service",
    //     label: "Part/Section to be Replaced",
    //     type: "dropdown",
    //     required: true,
    //     placeholder: "Select Complaint",
    //     options: [
    //       { label: "Vehicle", value: 0 },
    //       { label: "Motor", value: 1 },
    //       { label: "Controller", value: 2 },
    //       { label: "Battery", value: 3 },
    //       { label: "Converter", value: 4 },
    //       // { label: "Charger", value: 5 },
    //     ],
    //     gridClass: "col-lg-4",
    //   },
    //   // {
    //   //   name: "service_type",
    //   //   label: "Service Type",
    //   //   type: "dropdown",
    //   //   required: true,
    //   //   placeholder: "Select Complaint",
    //   //   // disabled: remainingDaysVal === 1 || remainingDaysVal <= 0 ? true : false ,
    //   //   // disabled: Object.values(remainingDaysVal).some(days => days <= 1) ? true : false,
    //   //   options: [
    //   //     { label: "Free Service", value: 0 },
    //   //     { label: "Paid Service", value: 1 },
    //   //     { label: "Within Warranty", value: 2 },
    //   //   ],
    //   //   gridClass: "col-lg-4",
    //   // },
    //   {
    //     name: "service_type",
    //     label: "Service Type",
    //     type: "dropdown",
    //     required: true,
    //     placeholder: "Select Complaint",
    //     options: [
    //       // ...(formData.type_of_service === 0
    //       //   ? [
    //       //       { label: "Free Service", value: 0 }, // Show this only for type_of_service === 0
    //       //     ]
    //       //   : []),
    //       { label: "Free Service", value: 0 },
    //       { label: "Paid Service", value: 1 },
    //       { label: "Within Warranty", value: 2 },
    //     ],
    //     gridClass: "col-lg-4",
    //   },
    //   // {
    //   //   name: "vehicle_km",
    //   //   label: "Kilometer ( applicable only in Motor and Battery )",
    //   //    type: "kilometertext",
    //   //   placeholder: "Enter Kilometer",
    //   //   // disabled: true,
    //   //   isComplaint: true,
    //   //   gridClass: "col-lg-4",
    //   // },

    //   // remainingdays: remainingDays < 0 ? "0.00" : remainingDays,
    //   //   {
    //   //     name: "is_claim",
    //   //     label: "Claim / If any",
    //   //     type: "dropdown",
    //   //     required: true,
    //   //     placeholder: "Select",
    //   //     options: [
    //   //       { label: "Yes", value: "1" },
    //   //       { label: "No", value: "0" },
    //   //     ],
    //   //     disabled:
    //   // formData.type_of_service !== undefined &&
    //   // (
    //   //   (formData.type_of_service === 0 && remainingDaysVal.remainingDays <= 0) ||
    //   //   (formData.type_of_service === 1 && remainingDaysVal.mtrremaining_days <= 0) ||
    //   //   (formData.type_of_service === 2 && remainingDaysVal.cntrlremaining_days <= 0) ||
    //   //   (formData.type_of_service === 3 && remainingDaysVal.btryremaining_days <= 0) ||
    //   //   (formData.type_of_service === 4 && remainingDaysVal.covrtremaining_days <= 0)
    //   // ),
    //   //     gridClass: "col-lg-4",
    //   //   },
    //   ...(formData.service_type === 1
    // ? [
    //     {
    //       name: "paid_amount",
    //       label: "Service Charges",
    //       type: "text",
    //       placeholder: "Enter Service Charges",
    //       gridClass: "col-lg-4",
    //     },
    //   ]
    // : []),
    //   {
    //     name: "is_claim",
    //     label: "Warranty Claim Type",
    //     type: "dropdown",
    //     required: true,
    //     placeholder: "Select",
    //     options: [
    //       { label: "Replacement", value: "1" },
    //       { label: "Repaired", value: "0" },
    //     ],
    //     disabled:
    //       formData.service_type === 1 || // Disable if service_type is 1
    //       (formData.type_of_service !== undefined &&
    //         ((formData.type_of_service === 0 &&
    //           remainingDaysVal.remainingDays <= 0) ||
    //           (formData.type_of_service === 1 &&
    //             remainingDaysVal.mtrremaining_days <= 0) ||
    //           (formData.type_of_service === 2 &&
    //             remainingDaysVal.cntrlremaining_days <= 0) ||
    //           (formData.type_of_service === 3 &&
    //             remainingDaysVal.btryremaining_days <= 0) ||
    //           (formData.type_of_service === 4 &&
    //             remainingDaysVal.covrtremaining_days <= 0))),
    //     gridClass: "col-lg-4",
    //   },
    //   {
    //     name: "uploadFile",
    //     label: "Reference Photo",
    //     type: "file",
    //     // required: true,
    //     gridClass: "col-lg-4",
    //     // validation: { required: true },
    //   },
  ];

  const NewBatteryInputs = [
    {
      name: 'newBatteryNos',
      label: 'New Item Nos',
      type: 'multiselectdropdown',
      required: true,
      placeholder: 'Select Complaint',
      options: replacedBattery,
      gridClass: 'col-lg-4',
    },
  ];

  const ComplaintInputs = [
    {
      name: 'remark',
      label: 'Complaint Details',
      type: 'text',
      placeholder: 'Enter Description',
      validation: { required: true },
      required: true,
      gridClass: 'col-lg-4',
    },
    // {
    //   name: "status",
    //   label: "Status",
    //   type: "dropdown",
    //   required: true,
    //   placeholder: "Select Complaint",
    //   options: [
    //     { label: "Pending", value: 0 },
    //     { label: "Done", value: 1 },
    //   ],
    //   gridClass: "col-lg-4",
    // },
    {
      name: 'type_of_service',
      label: 'Part/Section to be Replaced',
      type: 'dropdown',
      required: true,
      placeholder: 'Select Complaint',
      options: [
        // { label: "Vehicle", value: 0 },
        { label: 'Motor', value: 1 },
        { label: 'Controller', value: 2 },
        { label: 'Battery', value: 3 },
        { label: 'Converter', value: 4 },
        { label: 'Others', value: 5 },
      ],
      gridClass: 'col-lg-4',
      disabled: true,
      validation: { required: true },
    },
    ...(formData.type_of_service === 5
      ? [
          {
            name: 'other_job_card_name',
            label: 'Parts to be repaired',
            type: 'text',
            placeholder: 'Enter Parts to be repaired',
            gridClass: 'col-lg-4',
          },
        ]
      : []),

    // {
    //   name: "service_type",
    //   label: "Service Type",
    //   type: "dropdown",
    //   required: true,
    //   placeholder: "Select Complaint",
    //   // disabled: remainingDaysVal === 1 || remainingDaysVal <= 0 ? true : false ,
    //   // disabled: Object.values(remainingDaysVal).some(days => days <= 1) ? true : false,
    //   options: [
    //     { label: "Free Service", value: 0 },
    //     { label: "Paid Service", value: 1 },
    //     { label: "Within Warranty", value: 2 },
    //   ],
    //   gridClass: "col-lg-4",
    // },
    {
      name: 'service_type',
      label: 'Service Type',
      type: 'dropdown',
      // required: true,
      placeholder: 'Select Complaint',
      options: [
        // ...(formData.type_of_service === 0
        //   ? [
        //       { label: "Free Service", value: 0 }, // Show this only for type_of_service === 0
        //     ]
        //   : []),
        { label: 'Free Service', value: 0 },
        { label: 'Paid Service', value: 1 },
        // { label: "Within Warranty", value: 2 },
      ],
      gridClass: 'col-lg-4',

      disabled: true,
    },
    // {
    //   name: "vehicle_km",
    //   label: "Kilometer ( applicable only in Motor and Battery )",
    //    type: "kilometertext",
    //   placeholder: "Enter Kilometer",
    //   // disabled: true,
    //   isComplaint: true,
    //   gridClass: "col-lg-4",
    // },

    // remainingdays: remainingDays < 0 ? "0.00" : remainingDays,
    //   {
    //     name: "is_claim",
    //     label: "Claim / If any",
    //     type: "dropdown",
    //     required: true,
    //     placeholder: "Select",
    //     options: [
    //       { label: "Yes", value: "1" },
    //       { label: "No", value: "0" },
    //     ],
    //     disabled:
    // formData.type_of_service !== undefined &&
    // (
    //   (formData.type_of_service === 0 && remainingDaysVal.remainingDays <= 0) ||
    //   (formData.type_of_service === 1 && remainingDaysVal.mtrremaining_days <= 0) ||
    //   (formData.type_of_service === 2 && remainingDaysVal.cntrlremaining_days <= 0) ||
    //   (formData.type_of_service === 3 && remainingDaysVal.btryremaining_days <= 0) ||
    //   (formData.type_of_service === 4 && remainingDaysVal.covrtremaining_days <= 0)
    // ),
    //     gridClass: "col-lg-4",
    //   },
    ...(formData.service_type === 1
      ? [
          {
            name: 'paid_amount',
            label: 'Service Charges',
            type: 'text',
            placeholder: 'Enter Service Charges',
            gridClass: 'col-lg-4',
          },
        ]
      : []),
    {
      name: 'is_claim',
      label: 'Warranty Claim Type',
      type: 'dropdown',
      required: true,
      placeholder: 'Select',
      options: [
        { label: 'Replacement', value: '1' },
        { label: 'Repaired', value: '0' },
      ],
      gridClass: 'col-lg-4',
      disabled: true,
      validation: { required: true },
    },
    {
      name: 'stage_name_value',
      label: 'Stage Name',
      type: 'text',
      placeholder: 'Enter Stage Name Value',
      // validation: { required: true },
      // required: true,
      disabled: true,
      gridClass: 'col-lg-4',
    },
    {
      name: 'serial_nos_name',
      label: 'Serial Numbers',
      type: 'text',
      placeholder: 'Enter Serial No. Name',
      // validation: { required: true },
      // required: true,
      disabled: true,
      gridClass: 'col-lg-4',
    },
    // editJobcardDetails?.stage_status
    ...(editJobcardDetails?.stage_status === 1 ||
    editJobcardDetails?.stage_status === 9
      ? [
          {
            name: 'replaced_serial_nos_name',
            label: 'Replaced Serial Numbers',
            type: 'text',
            placeholder: 'Enter Serial No. Name',
            // validation: { required: true },
            // required: true,
            disabled: true,
            gridClass: 'col-lg-4',
          },
        ]
      : []),
    {
      name: 'status',
      label: 'Status',
      type: 'dropdown',
      required: true,
      placeholder: 'Select Complaint',
      options: [
        { label: 'Pending', value: 0 },
        { label: 'Done', value: 1 },
      ],
      gridClass: 'col-lg-4',
      validation: { required: true },
    },
    {
      name: 'uploadFile',
      label: 'Reference Photo',
      type: 'file',
      // required: true,
      gridClass: 'col-lg-4',
      // validation: { required: true },
    },
  ];

  const VehicleInputs = [
    {
      name: 'customer_id',
      label: 'Customer Name',
      type: 'dropdown',
      options: customerId,
      gridClass: 'col-lg-10',
      required: true,
      validation: { required: true },
    },
    {
      name: 'registrationno',
      label: 'Registration Number',
      type: 'text',
      required: true,
      gridClass: 'col-lg-10',
      placeholder: 'Enter Registration No.',
      validation: {
        required: true,
        maxLength: 12,
        pattern: /^[A-Za-z0-9]{10,12}$/,
        message:
          'Registration number must be exactly 12 alphanumeric characters. Special characters are not allowed.',
      },
      // disabled: true,
    },
    {
      name: 'chassisno',
      label: 'Chassis No.',
      type: 'text',
      required: true,
      gridClass: 'col-lg-10',
      placeholder: 'Enter Chassis No.',
      validation: {
        required: true,
        pattern: /^[A-Za-z0-9]{17}$/,
        message:
          'Chassis number must be exactly 17 alphanumeric characters. Special characters are not allowed.',
        maxLength: 17,
      },
      // disabled: true,
    },
    {
      name: 'engineno',
      label: 'Engine No.',
      type: 'text',
      required: true,
      gridClass: 'col-lg-10',
      placeholder: 'Enter Engine No.',
      validation: {
        required: true,
        pattern: /^[A-Za-z0-9.]{5,22}$/,
        message:
          'Engine number must be between 5 and 25 characters, and can only contain alphanumeric characters or dots.',
        maxLength: 22,
      },
      // disabled: true,
    },
    {
      name: 'mfgyear',
      label: 'Mfg. Year & Month.',
      type: 'date',
      required: true,
      gridClass: 'col-lg-10',
      showMonthYearPicker: true,
      validation: { required: true },
    },
    {
      name: 'product_id',
      label: 'Product',
      placeholder: 'Select City',
      type: 'dropdown',
      options: product,
      required: true,
      gridClass: 'col-lg-10',
    },
    {
      name: 'subproduct_id',
      label: 'Subproduct Name',
      type: 'dropdown',
      options: subproduct,
      gridClass: 'col-lg-10',
      required: true,
    },
    {
      name: 'make_id',
      label: 'Make',
      placeholder: 'Select City',
      type: 'dropdown',
      options: make,
      required: true,
      gridClass: 'col-lg-10',
    },
    {
      name: 'model_id',
      label: 'Model',
      placeholder: 'Select ',
      type: 'dropdown',
      options: model,
      required: true,
      gridClass: 'col-lg-10',
    },

    {
      name: 'variant_id',
      label: 'Variant',
      type: 'dropdown',
      options: variantDD,
      required: true,
      gridClass: 'col-lg-10',
      validation: { required: true },
    },
    {
      name: 'color_id',
      label: 'Color',
      type: 'dropdown',
      options: color,
      required: true,
      gridClass: 'col-lg-10',
      validation: { required: true },
    },
    {
      name: 'fuel_type_id',
      label: 'Fuel Type',
      type: 'dropdown',
      options: fuelType,
      required: true,
      gridClass: 'col-lg-10',
      validation: { required: true },
    },
    {
      name: 'extamount',
      label: 'Extra Amount',
      type: 'number',
      placeholder: 'Enter Amount',
      //required: true,
      gridClass: 'col-lg-10',
      validation: {
        maxLength: 10,
        pattern: /^\d+(\.\d{1,2})?$/, // Allows up to 2 decimal places
        message: 'Only digits and up to 2 decimal places are allowed',
      },
    },
    {
      name: 'isextwarranty',
      label: 'Extended Warranty',
      type: 'toggle',
      required: false,
      options: [{ label: 'Extended Warranty', value: 1 }],
      gridClass: 'col-lg-10',
    },
    {
      name: 'extwarrantystartdate',
      label: 'Start Date ',
      type: 'date',
      required: showParentDesignation ? true : false,
      isVisible: showParentDesignation,
      gridClass: 'col-lg-10',
      validation: { required: showParentDesignation ? true : false },
    },
    {
      name: 'extwarrantyenddate',
      label: 'End Date ',
      type: 'date',
      required: showParentDesignation ? true : false,
      isVisible: showParentDesignation,
      gridClass: 'col-lg-10',
      validation: { required: showParentDesignation ? true : false },
    },
  ];

  const CustomerFromInput = [
    {
      name: 'title_id',
      label: 'Title',
      type: 'dropdown',
      required: true,
      validation: { required: true },
      options: titleDD,
      gridClass: 'col-lg-10',
    },
    {
      name: 'first_name',
      label: 'First Name',
      type: 'text',
      required: true,
      placeholder: 'Enter First Name',
      gridClass: 'col-lg-10',
      validation: {
        required: true,
        pattern: /^[A-Za-z0-9-\s]*$/,
        message: 'Special symbols are not allowed',
        maxLength: 25,
      },
      // disabled: true,
    },
    {
      name: 'last_name',
      label: 'Last Name',
      type: 'text',
      placeholder: 'Enter Last Name',
      required: true,
      gridClass: 'col-lg-10',
      validation: {
        required: true,
        pattern: /^[A-Za-z0-9-\s]*$/,
        message: 'Special symbols are not allowed',
        maxLength: 25,
      },
      // disabled: true,
    },
    {
      name: 'mobile_no',
      label: 'Mobile No.',
      type: 'text',
      required: true,
      placeholder: 'Enter Mobile No.',
      gridClass: 'col-lg-10',
      validation: {
        required: true,
        pattern: /^[6-9]/,
        minLength: 10,
        maxLength: 10,
        message1: 'Contact no should start with 6, 7, 8, 9',
        message: 'Please enter a valid 10-digit',
      },
      // disabled: true,
    },
    // {
    //   name: "dob",
    //   label: "DOB",
    //   type: "date",
    //   maxDate: min18YearsAgo,
    //   required: true,
    //   gridClass: "col-lg-10",
    //   validation: { required: true, message: "DOB is required" },
    // },
    {
      name: 'email_id',
      label: 'Email Id',
      type: 'text',
      // required: true,
      placeholder: 'Enter Email Id',
      gridClass: 'col-lg-10',
      validation: {
        pattern: /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/,
        message: 'Please Enter Valid Email Id*',
        maxLength: 50,
      },
      // disabled: true,
    },
    {
      name: 'address',
      label: 'Address',
      type: 'text',
      required: true,
      placeholder: 'Enter Address',
      gridClass: 'col-lg-10',
      validation: { required: true, maxLength: 50 },
      // disabled: true,
    },
    {
      name: 'occupation_id',
      label: 'Occupation',
      type: 'dropdown',
      required: true,
      options: occupationDD,
      gridClass: 'col-lg-10',
      validation: { required: true },
    },
    {
      name: 'language_id',
      label: 'Language',
      type: 'dropdown',
      required: true,
      options: languageDD,
      gridClass: 'col-lg-10',
      validation: { required: true },
    },
    {
      name: 'pincode',
      label: 'Pin Code',
      placeholder: 'Enter Pin Code',
      type: 'text',
      required: true,
      gridClass: 'col-lg-10',
      validation: {
        required: true,
        maxLength: 6,
      },
    },
    {
      name: 'city',
      label: 'City',
      type: 'text',
      placeholder: 'City',
      gridClass: 'col-lg-10',
      //validation: { required: true },
      disabled: true,
    },
    {
      name: 'state',
      label: 'State',
      type: 'text',
      placeholder: 'State',
      //required: true,
      gridClass: 'col-lg-10',
      //validation: { required: true },
      disabled: true,
    },
    {
      name: 'country',
      label: 'Country',
      type: 'text',
      placeholder: 'Country',
      // required: true,
      gridClass: 'col-lg-10',
      ////  validation: { required: true },
      disabled: true,
    },
    // {
    //   name: "pan_no",
    //   label: "PAN No.",
    //   type: "text",
    //   placeholder: "Enter PAN No.",
    //   validation: {
    //     required: true,
    //     pattern: /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/,
    //     message: "Please enter a valid 10-character PAN number",
    //     maxLength: 10
    //   },
    //   required: false,
    //   gridClass: "col-lg-10",
    // },
  ];

  const Job_Card_TABLE_HEADERS = [
    'Product Name',
    'Chassis No.',
    'Model',
    'Variant',
    'Make',
    'Mobile No.',
    'Registration No.',
  ];

  // Key mapping for CustomTable component
  const BUSINESS_PARTNER_KEY_MAPPING = {
    // "Business Partner ID": "onboard_id",
    'Product Name': 'product_name',
    'Chassis No.': 'chassisno',
    Model: 'ModelName',
    Variant: 'VariantName',
    Make: 'MakeName',

    'Mobile No.': 'ContactNo',
    'Registration No.': 'registrationno',
  };

  const onClickModelVisible = () => {
    setSignatureModel(true);
  };

  const backNavigate = () => {
    navigate('/manage-services/check-warranty');
  };

  const handleClicableRow = (row) => {
    setFormData((pre) => ({
      ...pre,
      MobileNo: row?.ContactNo,
      Job_Card_Number: row?.JobNo,
      ChassisNo: row?.chassisno,
      Model: row?.ModelName,
      Make: row?.MakeName,
      RegNo: row?.registrationno,
      Warranty_Period: row?.warranty_value,
      Product: row?.product_name,
      SubProduct: row?.subproduct_name,
      Variant: row?.VariantName,
      ChassisNo: row?.chassisno,
      EngineNo: row?.engineno,
      Extended_Warranty: row?.ExtendedWarranty,
      Warranty_Start_Date: row?.WarrantyStartDate,
      Warranty_End_Date: row?.WarrantyEndDate,
      variant_id: row?.variant_id,
      make_id: row?.make_id,
      model_id: row?.model_id,
      Color: row?.color_name,
      fualType: row?.fuel_type_name,
      invoice_id: row?.invoice_id,
      quotation_id: row?.quotation_id,
      Extended_Warranty_start_date: row?.extwarrantystartdate,
      Extended_Warranty_end_date: row?.extwarrantyenddate,
    }));
    setVeriantListShow(false);
  };



  const editJobCard = async () => {
    try {
      const response = await axiosInstance.get(
        `/jobcard/edit/${jobCardDataDetails.job_card_id}`,
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
        },
      );
      if (response?.status) {
        const fetchedData = response?.data?.data[0];
        console.log(fetchedData, 'selectedEDitedData');

        console.log(fetchedData?.paid_service_amount, 'paid_service_amount');
        setPaidAmount(fetchedData?.paid_service_amount);

        setStatusVal(fetchedData?.status);

        console.log(fetchedData?.rejactRemark, 'RejectRemark');
        setRejectRemarkVal(fetchedData?.rejactRemark);
        console.log(fetchedData?.eng_remark_1, 'engRemarkOne');
        setRejectRemarkOne(fetchedData?.eng_remark_1);
        setFormData({
          Job_Card_Number: fetchedData?.job_card_no,
          transaction_date: fetchedData?.transaction_date,
          contact_no: fetchedData?.contact_no,
          registration_no: fetchedData?.registration_no,
          vin_no: fetchedData?.vin_no,
          pincode: fetchedData?.pincode,
          warrantyFrom: fetchedData?.warrantyFrom,
          warrantyTo: fetchedData?.warrantyTo,
          // claimName: fetchedData?.complainName,
          // remark: fetchedData?.remark,
          // status: fetchedData?.status,
          // is_claim: fetchedData?.is_claim,
          // uploadFile: fetchedData?.image_path,
          // repairStatus: fetchedData?.repairStatus,
          engineer_id: fetchedData?.engineer_id,
          // service_type: fetchedData?.service_type,
          // type_of_service: fetchedData?.type_of_service,
          paid_amount: fetchedData?.paid_amount,

          // is_claim:fetchedData?.is_claim,
        });
      }
    } catch (error) {
      console.error('Error fetching business partners:', error);
    }
  };

  const onclickOpenFrom = () => {
    setOpenCustomerModel(true);
  };

  // useEffect(() => {
  //   if (jobCardDataDetails?.job_card_id) {
  //     editJobCard(jobCardDataDetails?.job_card_id);
  //   }
  // }, [jobCardDataDetails?.job_card_id]);

  useEffect(() => {
    const fetchJobCardAndWarranty = async () => {
      if (jobCardDataDetails?.job_card_id) {
        await editJobCard();
      }
    };

    fetchJobCardAndWarranty();
  }, [jobCardDataDetails?.job_card_id]);

  useEffect(() => {
    if (formData.vin_no) {
      apiCall(formData); // Call apiCall only after formData.vin_no is updated
    }
  }, [formData.vin_no]);

  useEffect(() => {
    // Variantlist();
  }, [formData?.Customer_Name]);

  useEffect(() => {
    fetchJobCardList();
    // fetchCustomerList();
    // fetchSupervisorList();
  }, []);

  const formConfig = VehicleInputs.filter((input) => {
    if (['extwarrantyenddate', 'extwarrantystartdate'].includes(input.name)) {
      return showParentDesignation; // Include these inputs only if showParentDesignation is true
    }
    return true; // Include all other inputs
  });

  useEffect(() => {
    console.log(formData, 'FORMDATAStatus');
    if (formData?.isextwarranty === true) {
      setShowParentDesignation(true);
    }
  }, [formData?.isextwarranty]);

  const handleCustomerClick = () => {
    setActiveButton('customer');
    setShowVehicleForm(false);
    setFormData({
      Trans_Date: new Date(),
      Allocation_Date: new Date(),
    }); // Show the Customer form
  };

  const handleVehicleClick = () => {
    setActiveButton('vehicle');
    setShowVehicleForm(true); // Show the Vehicle form
    // fetchCustomerIdData();
    setFormData({
      Trans_Date: new Date(),
      Allocation_Date: new Date(),
    });
  };

  const onDeleteComplain = (row) => {
    const newcaplainData = complaindata.filter(
      (complainDetails, index) =>
        complainDetails?.complaintype !== row?.complaintype,
    );
    localStorage.setItem('JobCardComplainData', JSON.stringify(newcaplainData));
    setComplainData(newcaplainData);
    setTotalEstimatedCost(totalEstimatedCost - row.estcost);
    setFormData({ ...formData, JobEstimateAmount: totalEstimatedCost });
  };

  useEffect(() => {
    setFormData({ ...formData, JobEstimateAmount: totalEstimatedCost });
  }, [complaindata]);
  const capitalizeFirstLetter = (string) => {
    if (!string) return ''; // Handle empty string case
    return string.charAt(0).toUpperCase() + string.slice(1);
  };

  const currentDate = new Date().toISOString().split('T')[0];

  // Set current date only if it hasn't been set yet
  useEffect(() => {
    setFormData((prevData) => ({
      ...prevData,
      transaction_date: prevData.transaction_date || currentDate,
    }));
  }, [currentDate]);

  useEffect(() => {
    setFormData((prevData) => ({
      ...prevData,
      status: 0,
    }));
  }, []);

  //   useEffect(() => {

  // //     if( remainingDaysVal <= 0  ){
  // //       setFormData((prevData) => ({
  // //         ...prevData,
  // //         is_claim:"0"
  // //       }));
  // //     }else if(remainingDaysVal > 0 ){
  // //       setFormData((prevData) => ({
  // //         ...prevData,
  // //         is_claim:"1"
  // //       }));
  // //     }
  // //   }, [remainingDaysVal]);

  // useEffect(() => {
  //   if (formData.type_of_service !== undefined) {
  //     let remainingDaysKey = "";

  //     switch (formData.type_of_service) {
  //       case 0:
  //         remainingDaysKey = "remainingDays"; // Vehicle
  //         break;
  //       case 1:
  //         remainingDaysKey = "mtrremaining_days"; // Motor
  //         break;
  //       case 2:
  //         remainingDaysKey = "cntrlremaining_days"; // Controller
  //         break;
  //       case 3:
  //         remainingDaysKey = "btryremaining_days"; // Battery
  //         break;
  //       case 4:
  //         remainingDaysKey = "covrtremaining_days"; // Converter
  //         break;
  //       default:
  //         remainingDaysKey = "";
  //     }

  //     // Check if the selected service type's remaining days are <= 0
  //     if (remainingDaysKey && remainingDaysVal?.[remainingDaysKey] <= 0) {
  //       setFormData((prev) => ({
  //         ...prev,
  //         service_type: 1,
  //       }));
  //     } else {
  //       setFormData((prev) => ({
  //         ...prev,
  //         service_type: "",
  //       }));
  //     }
  //   }
  // }, [formData.type_of_service]);

  // useEffect(() => {
  //   if (formData.type_of_service !== undefined) {
  //     let remainingDaysKey = "";

  //     switch (formData.type_of_service) {
  //       case 0:
  //         remainingDaysKey = "remainingDays"; // Vehicle
  //         break;
  //       case 1:
  //         remainingDaysKey = "mtrremaining_days"; // Motor
  //         break;
  //       case 2:
  //         remainingDaysKey = "cntrlremaining_days"; // Controller
  //         break;
  //       case 3:
  //         remainingDaysKey = "btryremaining_days"; // Battery
  //         break;
  //       case 4:
  //         remainingDaysKey = "covrtremaining_days"; // Converter
  //         break;
  //       default:
  //         remainingDaysKey = "";
  //     }

  //     if (remainingDaysKey && remainingDaysVal?.[remainingDaysKey] <= 0) {
  //       setFormData((prev) => ({
  //         ...prev,
  //         is_claim: "0",
  //       }));
  //     } else {
  //       setFormData((prev) => ({
  //         ...prev,
  //         is_claim: "1", // Otherwise, reset to "0"
  //       }));
  //     }
  //   }
  // }, [formData.type_of_service]);

  const formatDate = (dateStr) => {
    if (!dateStr) return '';
    const date = new Date(dateStr);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Month is zero-based
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  };

  useEffect(() => {
    // Update all keys in formData whose remainingDaysVal is <= 0
    const updatedFormData = { ...formData };

    Object.keys(remainingDaysVal).forEach((key) => {
      if (remainingDaysVal[key] <= 0) {
        updatedFormData[key] = '0'; // Set corresponding key to "0"
      }
    });

    setFormData(updatedFormData);
  }, [remainingDaysVal]);

  const handleRejectUpdate = async (formData) => {
    const result = await Swal.fire({
      title: 'Confirmation',
      text: 'Are you sure you want to create this record?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes',
      cancelButtonText: 'No',
      showLoaderOnConfirm: true,
      preConfirm: async () => {
        try {
          const formattedDate = formatDate(formData?.tradeDate);
          // is_jod_card_no_generated
          // Create a FormData object to append data
          const formDataPayload = new FormData();
          formDataPayload.append('inspection_by', 'dealer');
          formDataPayload.append('transaction_date', formData.transaction_date);
          formDataPayload.append('contact_no', formData.contact_no);
          formDataPayload.append(
            'registration_no',
            formData.registration_no || '',
          );
          formDataPayload.append('vin_no', formData.vin_no);
          formDataPayload.append(
            'is_jod_card_no_generated',
            isJobCardCreated ? 1 : 0,
          );
          formDataPayload.append('pincode', formData.pincode);
          formDataPayload.append('remark', formData.remark);
          formDataPayload.append('status', formData.status);
          formDataPayload.append('is_claim', formData.is_claim);
          formDataPayload.append('reqNum', formData.vin_no);
          formDataPayload.append('reqType', 'V');

          formDataPayload.append('warrantyFrom', formData?.warrantyFrom || 0);
          formDataPayload.append('warrantyTo', formData?.warrantyTo || 0);
          formDataPayload.append('claimName', formData?.claimName || 0);
          formDataPayload.append('repairStatus', formData?.repairStatus || 0);
          formDataPayload.append('kiloMeter', kiloMeterData || 0);
          formDataPayload.append('cost', formData?.estCost || 0);
          formDataPayload.append('dealer_warrnty_date', formattedDate);
          formDataPayload.append(
            'type_of_service',
            formData?.type_of_service || 0,
          );
          formDataPayload.append('service_dealer_id', dealerId);
          formDataPayload.append('dealer_id', dealerIdData);
          formDataPayload.append('service_type', formData?.service_type || 0);
          formDataPayload.append('vehicle_km', formData?.vehicle_km || 0);
          formDataPayload.append('paid_amount', formData?.paid_amount || 0);

          // Append the uploaded file if it exists
          if (formData.uploadFile) {
            formDataPayload.append('uploadFile', formData.uploadFile);
          }
          // dealerIdData
          // API request to create the department
          const response = await axiosInstance.post(
            'jobcard/create',
            formDataPayload,
            {
              headers: {
                'Content-Type': 'multipart/form-data',
                Authorization: `Bearer ${token}`,
              },
            },
          );

          const responseData = response.data?.data?.responseData?.job_card_no;
          console.log(responseData, 'responseDataJobCardNumber');
          setJobCardNumber(responseData);

          if (response.status === 200) {
            Swal.fire({
              title: 'Success',
              text: 'Item added successfully!',
              icon: 'success',
              confirmButtonText: 'OK',
              // setFormData({

              // })
            }).then(() => {
              // navigate("/manage-services/check-warranty");
              setFormData((prev) => ({
                ...prev,
                remark: '',
                type_of_service: '',
                service_type: '',
                paid_amount: '',
                is_claim: '',
                uploadFile: null,
                status: '',
              }));
              setIsJobCardCreated(true);
              fetchProductList();
            });
          }
        } catch (error) {
          console.log(error, 'errorresponse');

          const errorMessage = error.response?.data?.data;
          console.log(errorMessage, 'errorMessage');

          showErrorAlert({
            title: 'Warning',
            text: errorMessage || 'Something went wrong',
            callback: () => {
              console.log('Error alert confirmed');
            },
          });
        }
      },
    });

    if (!result.isConfirmed) {
      // setLoading(false);
    }
  };

  const handleDelete = async (rowData) => {
    console.log('clicked', rowData);
    try {
      const response = await axiosInstance.get(
        `/jobcard/deleteSubJobCard/${rowData.job_card_id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );

      if (response.status === 200) {
        console.log('Item deleted successfully');
        fetchProductList();
      } else {
        console.error('Failed to delete item');
      }
    } catch (error) {
      console.error('Error deleting item:', error);
    }
  };

  useEffect(() => {
    if (
      formData?.type_of_service === 3 ||
      formData?.type_of_service === 2 ||
      formData?.type_of_service === 1
    ) {
      fetchBatteryDetails();
    }
  }, [formData?.type_of_service]);

  const fetchBatteryDetails = async () => {
    try {
      setLoading(true);
      const response = await axiosInstance.post(
        '/jobcard/battery-details',
        {
          vin_no: formData?.vin_no || '',
          type_of_service: formData?.type_of_service,
        },
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
        },
      );

      const formattedData = response?.data?.data?.map((item, index) => ({
        ...item,
        'Sr No.': index + 1,
      }));

      const itemId = response?.data?.data[0]?.item_id;
      console.log(itemId, 'itemIddddd');
      setItemIdVal(itemId);

      setBatteryDetails(formattedData);
    } catch (error) {
      console.error('Error fetching model list:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (batteryModalOpen === true) {
      fetchBatteryToBeReplaced();
    }
  }, [batteryModalOpen]);

  const fetchBatteryToBeReplaced = async () => {
    try {
      const response = await axiosInstance.post(
        '/jobcard/replace-battery-ddl',

        {
          item_id: itemIdVal,
          dealer_id: dealerId,
          type_of_service: formData?.type_of_service,
        },
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
        },
      );

      const data = response?.data?.data;

      const dealerOptions = data.map((dealer) => ({
        value: dealer.NAME,
        label: dealer.ID,
      }));

      setReplacedBattery(dealerOptions);
    } catch (error) {
      console.log(error);
    }
  };

  const batteryReplacementSubmit = async (formData) => {
    console.log('clicked');
    try {
      setLoading(true);

      const payload = {
        vinNo: formData.vin_no,
        newBatteryNos: formData.newBatteryNos,
        oldBatteryNos: selectedOldBatteries,
        jobCardId: jobCardDataDetails?.job_card_id,
        is_claim: formData?.is_claim,
        type_of_service: formData?.type_of_service,
        //   if (formData?.type_of_service !== undefined && formData?.type_of_service !== null) {
        // payload.type_of_service = formData.type_of_service;
        // }
      };

      // API request to create the new model
      const response = await axiosInstance.post(
        '/jobcard/update-replace-battery',
        payload,
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
        },
      );

      // Show success alert using the reusable alert
      // if (response.status === 200) {
      //   await showAlert({
      //     title: "Success",
      //     text: "Item Replaced Successfully.",
      //     icon: "success",
      //     confirmButtonText: "OK",
      //   });

      //   // Navigate to model management page after success
      //   // navigate("/admin/manage-product/model");
      // }

      if (response.status === 200) {
        const successMessage = 'Item processed successfully.';

        await showAlert({
          title: 'Success',
          text: successMessage,
          icon: 'success',
          confirmButtonText: 'OK',
        });
      }

      if (response.status !== 200) {
        throw new Error('Battery replacement failed');
      }

      return true;
    } catch (error) {
      console.error('Error submitting form:', error?.response?.data?.data);

      // Show error alert using the reusable alert
      const errorMessage =
        error?.response?.data?.data ||
        'An error occurred while processing your request.';
      showAlert({
        title: 'Error',
        text: errorMessage,
        icon: 'error',
        confirmButtonText: 'OK',
      });

      throw error;
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    // if (jobCardNo) {
    fetchProductList();
    // }
  }, []);

  const fetchProductList = async (page = 0, pageSize = 10) => {
    try {
      // const allfilteredData = filters;

      setLoading(true);
      const response = await axiosInstance.post(
        '/jobcard/listOfVinNo',
        {
          // orderBy: 'product_id desc',
          page,
          pageSize,
          job_card_no: jobCardDataDetails?.job_card_no,
          // searchText: searchTerm,
          // variant_id: allfilteredData?.variantId
          //   ? allfilteredData?.variantId
          //   : null,
          // stateId: allfilteredData?.stateId ? allfilteredData?.stateId : null,
          // // fromDate: allfilteredData?.fromDate ? allfilteredData?.fromDate : null,
          // // toDate: allfilteredData?.fromDate ? allfilteredData?.toDate : null,
          // startDate: formatDate(allfilteredData?.fromDate),
          // endDate: formatDate(allfilteredData?.toDate),
        },
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
        },
      );

      const formattedData = response?.data?.data?.data?.map((item, index) => ({
        ...item,
        'Sr No.': index + 1 + page * pageSize,
        status: item.status === 0 ? 'Pending' : 'Completed',
      }));

      console.log(response?.data?.data?.data?.data, 'productListData');

      const totalRecordsData = response?.data?.data?.totalRecords;
      const totalCount = response?.data?.data?.total;
      const totalAct = response?.data?.data?.total_active;
      const totalInac = response?.data?.data?.total_inactive;

      // setTotalData(totalCount);
      // setTotalActive(totalAct);
      // setTotalInactive(totalInac);

      console.log(totalRecordsData, 'RECORDS');
      setTotalRecords(totalRecordsData);

      setProductData(formattedData);
      setTotalPages(Math.ceil(response?.data?.data?.totalRecords / pageSize));
    } catch (error) {
      console.error('Error fetching product list:', error);
    } finally {
      setLoading(false);
    }
  };

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
    fetchProductList(newPage);
  };

  const handleEdit = async (rowData) => {
    console.log(rowData, 'rowDataDetails');
    try {
      const response = await axiosInstance.get(
        `/jobcard/subEdit/${rowData.job_card_id}`,
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
        },
      );
      if (response?.status) {
        const fetchedData = response?.data?.data[0];
        console.log(fetchedData, 'selectedEDitedData');

        setFormData((prevData) => ({
          ...prevData,
          remark: fetchedData?.remark,
          status: fetchedData?.status,
          is_claim: fetchedData?.is_claim,
          uploadFile: fetchedData?.image_path,
          // repairStatus: fetchedData?.repairStatus,
          // engineer_id: fetchedData?.engineer_id,
          other_job_card_name: fetchedData?.other_job_card_name,
          service_type: fetchedData?.service_type,
          type_of_service: fetchedData?.type_of_service,
          paid_amount: fetchedData?.paid_amount,
          stage_name_value: fetchedData?.stage_name,
          serial_nos_name: fetchedData?.serial_no,
          replaced_serial_nos_name: fetchedData?.replace_serial_no,
          is_claim: fetchedData?.is_claim,
        }));

        console.log(fetchedData, 'fetchedDataDetails');

        setJobCardIdVal(fetchedData?.job_card_id);
        setEditJobcardDetails(fetchedData);

        // setFormData({
        //   remark: fetchedData?.remark,
        //   status: fetchedData?.status,
        //   is_claim: fetchedData?.is_claim,
        //   uploadFile: fetchedData?.image_path,
        //   // repairStatus: fetchedData?.repairStatus,
        //   // engineer_id: fetchedData?.engineer_id,
        //   service_type: fetchedData?.service_type,
        //   type_of_service: fetchedData?.type_of_service,
        //   paid_amount: fetchedData?.paid_amount,

        //   is_claim:fetchedData?.is_claim,
        // });
      }
    } catch (error) {
      console.error('Error fetching business partners:', error);
    }
  };

  // const handleBatterySubmit = () => {
  //   const oldBatteryCount = selectedOldBatteries.length;
  //   const newBatteryCount = formData?.newBatteryNos?.length || 0;

  //   if (oldBatteryCount !== newBatteryCount) {
  //     alert(
  //       `Number of old batteries selected (${oldBatteryCount}) must match the number of new batteries selected (${newBatteryCount}).`
  //     );
  //     return; // ❌ stop submit
  //   }

  //   // ✅ counts match → proceed
  //   // batteryReplacementSubmit(formData);
  //   toggleBatteryModalClose();
  // };

  const handleBatterySubmit = () => {
    const oldBatteryCount = selectedOldBatteries.length;
    const newBatteryCount = formData?.newBatteryNos?.length || 0;

    if (newBatteryCount > 0 && oldBatteryCount !== newBatteryCount) {
      alert(
        `Number of old batteries selected (${oldBatteryCount}) must match the number of new batteries selected (${newBatteryCount}).`,
      );
      return; // stop submit
    }

    toggleBatteryModalClose();
  };

  return (
    <>
      <div>
        {loading ? (
          <Loader />
        ) : (
          <div>
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                paddingRight: '10px',
              }}
            >
              <div className="backbutton mt-2 mb-2">
                <img onClick={backNavigate} src={backicon} alt="back" />
                <span className="backbtntitle">
                  {jobCardDataDetails?.job_card_id
                    ? 'Update Job Card '
                    : 'Add Job Card'}
                </span>
              </div>

              <div className="btncontainer mt-3">
                {/* <button
                  onClick={openSubmitModal}
                  className="submit-btn"
                >
                  Submit
                </button> */}

                {/* <button
                  onClick={() => {
                    if (statusVal === 1) {
                      handleRejectUpdate(formData);
                    } else {
                      openSubmitModal();
                    }
                  }}
                  className="submit-btn"
                >
                  Submit
                </button> */}
              </div>
            </div>
            <div className="form-container">
              <div className="cust-det-title mt-2 mb-2">
                Please Enter Job Card Details
              </div>

              {/* <div className="btncontainer mt-3">
        <button
       
          onClick={() => {
            handleFormSubmit(formData);
          }}
          className="submit-btn"
        >
       Submit
        </button>
      </div> */}

              <DynamicForm
                formConfig={
                  CustomerInputs?.map((inputFilde) => {
                    if (inputFilde?.name === 'Extended_Warranty_start_date') {
                      return {
                        ...inputFilde,
                        isVisible: formData?.Extended_Warranty === 1,
                      };
                    }
                    if (inputFilde?.name === 'Extended_Warranty_end_date') {
                      return {
                        ...inputFilde,
                        isVisible: formData?.Extended_Warranty === 1,
                      };
                    }
                    return inputFilde;
                  }) || []
                }
                formData={formData}
                setFormData={setFormData}
                onSubmit={handleFormSubmit}
                validationErrors={validationErrors}
                setValidationErrors={setValidationErrors}
                buttonOnclick={onClickModelVisible}
                addComplainHandler={toggleDrawer}
                onclickOpenFrom={onclickOpenFrom}
                apiCall={apiCall}
              />
              <span className="cust-det-title mt-2 mb-2">
                Complaint Details
              </span>
              <DynamicForm
                formConfig={ComplaintInputs}
                formData={formData}
                setFormData={setFormData}
                // exshowroomprice={formData?.exshowroomprice}
                onSubmit={handleFormSubmit}
                validationErrors={validationErrors}
                setValidationErrors={setValidationErrors}
              />
              <div style={{ gap: '1rem' }} className="btncontainer mt-3">
                {editJobcardDetails?.stage_status === null ||
                editJobcardDetails?.stage_status < 1 ? (
                  <button
                    onClick={toggleBatteryModalOpen}
                    className="submit-btn"
                  >
                    Replace Item
                  </button>
                ) : null}

                {/* <button
                  onClick={() => {
                    handleUpdate(formData);
                  }}
                  className="submit-btn"
                >
                  Save
                </button> */}
                {/* <button
                  onClick={() => {
                    // if (statusVal === 1) {
                    //   handleRejectUpdate(formData);
                    // } else {
                    openSubmitModal();
                    // }
                  }}
                  className="submit-btn"
                >
                  Submit
                </button> */}
                <button
                  onClick={() => {
                    const isValid = validateForm(formData);

                    if (!isValid) return;

                    openSubmitModal();
                  }}
                  className="submit-btn"
                >
                  Submit
                </button>
              </div>
              <CustomTable
                data={productData}
                headers={TABLE_HEADERS}
                keyMapping={keyMapping}
                itemsPerPage={10}
                currentPage={currentPage}
                totalPages={totalPages}
                onPageChange={handlePageChange}
                onEdit={handleEdit}
                totalRecords={totalRecords}
                handleDelete={handleDelete}
              />

              {batteryModalOpen && (
                <div className="customModalOverlayBattery">
                  <div className="custom-modal-expectedDate-battery">
                    <div className="custom-modal-header-battery">
                      <h6 style={{ fontSize: '18px' }}>Item Details</h6>
                      <button
                        className="close-button"
                        onClick={toggleBatteryModalClose}
                      >
                        ×
                      </button>
                    </div>

                    {editJobcardDetails?.stage_status >= 1 ? (
                      /* -------------------- SMALL UI -------------------- */
                      <div
                        style={{
                          width: '100%',
                          maxWidth: '500px',
                          margin: '50px 0px',
                          // padding: "25px 30px",
                          // backgroundColor: "#ffffff",
                          // borderRadius: "14px",
                          // boxShadow: "0 6px 18px rgba(0, 0, 0, 0.08)",
                          // border: "1px solid #f0f0f0",
                          // textAlign: "center",
                          gap: '18px',
                          display: 'flex',
                          flexDirection: 'column',
                          // justifyContent: "center",
                          // alignItems: "center",
                          // gap: "1.5rem",
                        }}
                      >
                        <p
                          style={{
                            fontSize: '18px',
                            fontWeight: '600',
                            marginBottom: '18px',
                            color: '#333',
                          }}
                        >
                          <span
                            style={{
                              fontWeight: '600',
                              color: '#7BD755',
                              marginRight: '8px',
                            }}
                          >
                            Stage Name:
                          </span>
                          <span style={{ fontWeight: '500', color: '#222' }}>
                            {editJobcardDetails?.stage_name}
                          </span>
                        </p>

                        <p
                          style={{
                            fontSize: '16px',
                            margin: '0',
                            color: '#555',
                          }}
                        >
                          <span
                            style={{
                              fontWeight: '600',
                              color: '#7BD755',
                              marginRight: '8px',
                            }}
                          >
                            Serial Nos:
                          </span>
                          <span style={{ fontWeight: '500', color: '#222' }}>
                            {editJobcardDetails?.serial_no}
                          </span>
                        </p>
                      </div>
                    ) : (
                      /* -------------------- BIG BATTERY UI -------------------- */
                      <div>
                        <div
                          className="custom-modal-body-battery"
                          style={{ maxHeight: '600px', overflowY: 'auto' }}
                        >
                          {batteryDetails && batteryDetails.length > 0 ? (
                            Object.values(
                              batteryDetails.reduce((acc, item) => {
                                if (!acc[item.item_name])
                                  acc[item.item_name] = [];
                                acc[item.item_name].push(item);
                                return acc;
                              }, {}),
                            ).map((group, index) => (
                              <div key={index} style={{ marginBottom: '20px' }}>
                                <h6
                                  style={{
                                    fontWeight: '600',
                                    marginBottom: '10px',
                                  }}
                                >
                                  {group[0].item_name}
                                </h6>

                                {group.map((battery) => (
                                  <div
                                    key={battery.battery_no}
                                    style={{
                                      display: 'flex',
                                      alignItems: 'center',
                                      gap: '10px',
                                      marginBottom: '6px',
                                    }}
                                  >
                                    <input
                                      type="checkbox"
                                      id={battery.battery_no}
                                      value={battery.battery_no}
                                      checked={selectedOldBatteries.includes(
                                        battery.battery_no,
                                      )}
                                      onChange={(e) =>
                                        handleOldBatterySelect(
                                          e,
                                          battery.battery_no,
                                        )
                                      }
                                    />
                                    <label htmlFor={battery.battery_no}>
                                      {battery.battery_no}
                                    </label>
                                  </div>
                                ))}
                              </div>
                            ))
                          ) : (
                            <p>No Item details found.</p>
                          )}
                        </div>

                        {replacedBattery && replacedBattery.length > 0 ? (
                          <div>
                            <span
                              style={{ fontSize: '14px' }}
                              className="cust-det-title mt-2 mb-2"
                            >
                              Please Enter Serial Numbers
                            </span>

                            <DynamicForm
                              formConfig={NewBatteryInputs}
                              formData={formData}
                              setFormData={setFormData}
                              validationErrors={validationErrors}
                              setValidationErrors={setValidationErrors}
                            />
                          </div>
                        ) : null}

                        <div className="custom-modal-footer-battery">
                          <button
                            className="btn btn-primary"
                            style={{
                              background: '#7BD755',
                              color: 'white',
                              border: 'none',
                              borderRadius: '20px',
                              padding: '10px 28px',
                            }}
                            onClick={handleBatterySubmit}
                          >
                            Submit
                          </button>

                          <button
                            className="btn btn-primary"
                            style={{
                              background: 'white',
                              color: '#7BD755',
                              border: '1px solid #7BD755',
                              borderRadius: '20px',
                              padding: '10px 28px',
                            }}
                            onClick={toggleBatteryModalClose}
                          >
                            Cancel
                          </button>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              )}

              {/* Submit Modal */}
              {isModalOpen && (
                <div className="customModalOverlay">
                  <div className="custom-modal">
                    <div className="custom-modal-header">
                      <h6 style={{ fontSize: '18px' }}>Remarks</h6>
                      <button className="close-button" onClick={closeModal}>
                        ×
                      </button>
                    </div>
                    <div className="custom-modal-body">
                      <DynamicForm
                        formConfig={ModalInputs}
                        formData={formData}
                        setFormData={setFormData}
                        onSubmit={handleFormSubmit}
                        validationErrors={validationErrors}
                        setValidationErrors={setValidationErrors}
                      />
                      <label>
                        Remark<span className="required-asterisk">*</span>
                      </label>
                      <textarea
                        value={remark}
                        onChange={(e) => {
                          setRemark(e.target.value);
                          if (e.target.value.trim()) {
                            setRemarkError(''); // Clear error when user starts typing
                          }
                        }}
                        placeholder="Add your remark here"
                        rows="4"
                        className="remark-textarea"
                      />
                      {remarkError && (
                        <p style={{ color: 'red', fontSize: '1rem' }}>
                          {remarkError}
                        </p>
                      )}
                    </div>
                    <div className="custom-modal-footer">
                      <button
                        className="btn btn-primary"
                        style={{
                          background: '#7BD755',
                          color: 'white',
                          border: 'none',
                          borderRadius: '20px',
                          padding: ' 10px 28px',
                        }}
                        onClick={() => {
                          if (!remark.trim()) {
                            setRemarkError('Please enter a remark.');
                            return;
                          }
                          setRemarkError('');
                          handleUpdate(formData);
                          handleUpdateVinNumber(formData);
                        }}
                      >
                        Submit
                      </button>
                      <button
                        className="btn btn-primary"
                        style={{
                          background: 'white',
                          color: '#7BD755',
                          border: '1px solid #7BD755',
                          borderRadius: '20px',
                          padding: ' 10px 28px',
                        }}
                        onClick={closeModal}
                      >
                        Cancel
                      </button>
                    </div>
                  </div>
                </div>
              )}

              {VeriantListShow && (
                <Modal
                  show={VeriantListShow}
                  onHide={() => setVeriantListShow(false)}
                  centered
                  size="lg"
                  //  className="large"
                >
                  <Modal.Header closeButton>
                    <Modal.Title>Vehicle Selection</Modal.Title>
                  </Modal.Header>
                  <Modal.Body>
                    <DetailsTable
                      data={veriantListData || []}
                      headers={Job_Card_TABLE_HEADERS}
                      keyMapping={BUSINESS_PARTNER_KEY_MAPPING}
                      // onEdit={handleEdit}
                      // handleViewButton={handleViewButton} // Pass the handleEdit function
                      itemsPerPage={10}
                      // currentPage={currentPage}
                      // totalPages={totalPages}
                      // onPageChange={handlePageChange}
                      handleClicableRow={handleClicableRow}
                    />
                  </Modal.Body>
                </Modal>
              )}
              <Offcanvas
                placement={'end'}
                show={openCustomerModel}
                onHide={handleClose}
                style={{ width: '580px' }}
              >
                <Offcanvas.Header style={{ padding: '35px 70px 10px 70px' }}>
                  <Offcanvas.Title>
                    <div
                      className="backbutton"
                      style={{
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                      }}
                    >
                      <img
                        src={backicon}
                        alt="back"
                        style={{ paddingBottom: '12px' }}
                        onClick={handleClose}
                      />
                      <p
                        style={{
                          fontSize: '24px',
                          fontWeight: '500',
                          paddingLeft: '5px',
                        }}
                      >
                        Add {capitalizeFirstLetter(activeButton)}
                      </p>
                    </div>
                    <div
                      className="col-12"
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '10px',
                        paddingTop: '14px',
                      }}
                    >
                      <button
                        onClick={handleCustomerClick}
                        className={
                          activeButton === 'customer'
                            ? ' vehicle-btn p-3'
                            : 'tab-btn p-3'
                        }
                        style={{ width: '194px' }}
                      >
                        {'Customer'}
                      </button>
                      <button
                        onClick={handleVehicleClick}
                        className={
                          activeButton === 'vehicle'
                            ? ' vehicle-btn p-3'
                            : 'tab-btn p-3'
                        }
                        style={{ width: '194px' }}
                      >
                        {'Vehicle'}
                      </button>
                    </div>
                  </Offcanvas.Title>
                </Offcanvas.Header>
                <Offcanvas.Body style={{ padding: '0px 50px' }}>
                  {!showVehicleForm ? (
                    // Render the Customer Form
                    <div
                      style={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        marginLeft: '80px',
                      }}
                    >
                      <AddIssueDynemicForm
                        formConfig={CustomerFromInput}
                        formData={formData}
                        setFormData={setFormData}
                        onSubmit={handleDrawerFormCustomer}
                        validationErrors={validationErrors}
                        setValidationErrors={setValidationErrors}
                        showParentDesignation={showParentDesignation}
                        setShowParentDesignation={setShowParentDesignation}
                      />

                      <div
                        style={{ paddingTop: '10px', paddingLeft: '52px' }}
                        className="col-12"
                      >
                        <button
                          onClick={() => handleDrawerFormCustomer(formData)}
                          className="submit-btn w-50 p-3 "
                        >
                          {'Save and Continue'}
                        </button>
                      </div>
                    </div>
                  ) : (
                    // Render the Vehicle Form
                    <div
                      style={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        marginLeft: '80px',
                      }}
                    >
                      <AddIssueDynemicForm
                        formConfig={formConfig}
                        formData={formData}
                        setFormData={setFormData}
                        onSubmit={handleDrawerFormVehicle}
                        validationErrors={validationErrors}
                        setValidationErrors={setValidationErrors}
                        showParentDesignation={showParentDesignation}
                        setShowParentDesignation={setShowParentDesignation}
                      />

                      <div
                        className="col-12"
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: '10px',
                        }}
                      >
                        <button
                          onClick={handleBackToCustomerForm}
                          className="clear-btn p-3"
                          style={{ width: '120px' }}
                        >
                          {'Back'}
                        </button>
                        <button
                          onClick={() => handleDrawerFormVehicle(formData)}
                          className="submit-btn p-3"
                          style={{ width: '120px' }}
                        >
                          {'Save'}
                        </button>
                      </div>
                    </div>
                  )}
                </Offcanvas.Body>
              </Offcanvas>
            </div>
            <>
              {' '}
              {isOpen && (
                <Drawer
                  size={500}
                  open={isOpen}
                  onClose={toggleDrawer}
                  direction="right"
                  className="bla bla bla"
                >
                  <div style={{ padding: '30px' }}>
                    <div
                      style={{ paddingLeft: '46px' }}
                      className="backbutton"
                      onClick={toggleDrawer}
                    >
                      <img src={backicon} alt="back" />
                      <span className="backbtntitleDetails">Add Complain</span>
                    </div>

                    <div className="mt-3" style={{ paddingLeft: '44px' }}>
                      {/* <AddComplain
                  complaindata={complaindata}
                  toggleDrawer={toggleDrawer}
                  setTotalEstimatedCost={setTotalEstimatedCost}
                  setComplainData={setComplainData}
                  vinNoValData={vinNoValData}
                /> */}
                    </div>
                    {/* <hr /> */}
                  </div>
                </Drawer>
              )}
            </>
            {/* {!jobCardDataDetails?.job_card_id && complaindata.length > 0 && */}
            {/* <div className="btncontainer mt-3">
        <button
       
          onClick={() => {
            handleFormSubmit(formData);
          }}
          className="submit-btn"
        >
       Submit
        </button>
      </div> */}
            {/* } */}
            <div>
              {/* {!jobCardDataDetails?.job_card_id && complaindata.length > 0 && (
          <div>
            <CustomTable
              data={complaindata}
              isADDcomplainTable={true}
              headers={COMPLAIN_TABLE_HEADERS}
              keyMapping={ComplainkeyMapping}
              onDelete={onDeleteComplain}
            />
          </div>
        )} */}
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default EditJobCard;
